import React, { useEffect, useState, useRef } from "react";
import { ScrollContainer } from "react-indiana-drag-scroll";
import { useNavigate } from "react-router";
import Modal from "react-bootstrap/Modal";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  SlTab,
  SlTabGroup,
  SlTabPanel,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { CSVLink } from "react-csv";
import Advertiser from "../createUser/Advertiser";
import Sales from "../createUser/Sales";
import Finance from "../createUser/Finance";
import ConsolidatedReport from "./ConsolidatedReport";
import EcpmReport from "./EcpmReport";
// import { Formik, Form, Field } from 'formik';
import PreviewFrameEdit from "../PreviewFrameEdit";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
// import Button from 'react-bootstrap/Button';
import {
  SlIconButton,
  SlDrawer,
  SlTooltip,
} from "@shoelace-style/shoelace/dist/react";
import {
  SlOption,
  SlSelect,
  SlButton,
  SlInput,
} from "@shoelace-style/shoelace/dist/react";
import async from "async";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import {
  formatDate,
  formatDateWithTime,
  formatDateYYYYMMDD,
  ISODateString,
} from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import NoDataFound from "../../shared/NoDataFound";
import {
  campaignStatus,
  reportStatus,
  roles,
  stateOptions,
  languageOptions,
  removeCommonLocation,
  teams,
} from "../../utils/constants";
import Paginator from "../../shared/Paginator";
import { debounce } from "../../utils/Debounce";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config";
import DayWiseReport from "./DayWiseReport";
import CreativewiseReport from "./CreativewiseReport";
import LangwiseReport from "./LangwiseReport";
import StatewiseReport from "./StatewiseReport";
import DistrictwiseReport from "./DistrictwiseReport";
import MandalwiseReport from "./MandalwiseReport";
import OswiseReport from "./OswiseReport";
import ModelwiseReport from "./ModelwiseReport";
import BrandwiseReport from "./BrandwiseReport";
import CategorywiseReport from "./CategorywiseReport";
import { SetComponentId } from "../../redux/counterSlice";
import createdSVG from "../../../src/assets/images/created.svg";
import runningSVG from "../../../src/assets/images/running.svg";
import pausedSVG from "../../../src/assets/images/paused.svg";
import completedSVG from "../../../src/assets/images/completed.svg";
import scheduledSVG from "../../../src/assets/images/scheduled.svg";
import whatsappIcon from "../../assets/images/whatsapp.svg";
import Select from "react-select";
import TeamwiseReports from "./TeamwiseReports";
import SalesPersonwiseReport from "./SalesPersonwiseReport";
import { useForm } from "react-hook-form";
import { saveAs } from "file-saver";
import { toBlob, toPng } from "html-to-image";
import ComparisonReport from "./ComparisonReport";
import ConsolidatedNational from "./ConsolidatedNational";
import TeamwiseNational from "./TeamwiseNational";
import PositionwiseImpressions from "./PositionwiseImpressions";
import AlphaTeamReports from "./AlphaTeamReports";
import InboundSaleCampaigns from "./InboundSalesCampaigns";
import LocalSalesCampaigns from "./LocalSalesCampaigns";
import MetroSalesCampaigns from "./MetroSalesCampaigns";
import AlphaSalesCampaigns from "./AlphaSalesCampaigns";
import PackageAdReport from "./PackageAdReport";
import FinanceReport from "./FinanceReport";

const actiontypeoptions = ["Shuffle", "Round robin"];
export const reportCreativeContext = React.createContext();
function Reports() {
  const dispatch = useDispatch();
  dispatch(SetComponentId(15));
  const [data, setData] = useState([]);
  const [reportImage, setReportImage] = useState();
  const [reportImageUrl, setReportImageUrl] = useState();
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [tarshow, setTarshow] = useState(false);
  const [targetdetails, setTargetdetails] = useState({
    age: { min: "", max: "" },
  });
  const [downloadData, setDownloadData] = useState([]);
  const [actual_target, setactual_target] = useState({});
  const [campaigndetails, setcampaigndetails] = useState({});
  const [formshow, setFormshow] = useState(false);
  const [search, setSearch] = useState("");
  const [campaignType, setCampaignType] = useState("all");
  const [tab, setTab] = useState("Date wise");
  const [dateFilter, setDateFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateFormatted, setStartDateFormatted] = useState("");
  const [endDateFormatted, setEndDateFormatted] = useState("");
  const [x_filter, setX_filter] = useState(0);
  const [status, setStatus] = useState(-1);
  const [currentPage, setCurrentPage] = useState(0);
  const [dayshow, setDayshow] = useState(false);
  const HeaderSearch = useSelector((state) => state.Head.adssearch);
  const Headdate = useSelector((state) => state.Head.date);
  const [initialRender, setInitialRender] = useState(true);
  const genderOptions = ["All", "Male", "Female"];
  const osOptions = ["All", "Android", "IOS"];
  const appCategoryOptions = [
    "All",
    "News",
    "Business",
    "Sports",
    "Cinema",
    "Special",
    "Politics",
  ];
  const langoptions = [
    "",
    "Telugu",
    "Tamil",
    "Hindi",
    "Kannada",
    "Malayalam",
    "Marathi",
    "Bengali",
    "Gujarati",
    "Punjabi",
    "Odia",
    "English",
    "",
    "Telugu-English"
  ];
  const payments = ["Unpaid", "Paid", "Wayoff"];

  const [statefilter, setStatefilter] = useState(-1);
  const [langfilter, setLangFilter] = useState(-1);
  const [districtselect, setSelectdistrict] = useState(-1);
  const [districtfilter, setDistrictfilter] = useState([]);
  const [mandalfilter, setMandalfilter] = useState([]);
  const [target_filter, setTarget_filter] = useState({});
  const [previewdata, setPreview] = useState({});
  const [advlist, setAdvlist] = useState([]);
  const [saleslist, setSaleslist] = useState([]);
  const [campCategory, setCampCategory] = useState([]);
  const [creative_Names, setCreative_Names] = useState([]);
  const [opsName, setopsName] = useState([]);
  var timeslots = [{ sdate: "", edate: "" }];
  const [deptlist, setDepartment] = useState([]);
  const [group_index, setGroup_index] = useState(-1);
  const [showWhatsapp, setShowWhatsapp] = useState(false);
  const [month, setMonth] = useState(`${new Date().getMonth() + 1}`);
  const [year, setYear] = useState(`${new Date().getFullYear()}`);

  const [group_target_Actual_ids, setGroup_target_Actual_ids] = useState([]);
  const [group_target_dataArray, setGroup_target_dataArray] = useState([]);
  const SALES = useSelector((state) => state.Head.opssales);

  const csvLinkRef = useRef(); // Create a ref for CSVLink
  const downloadcsvLinkRef = useRef(); // Create a ref for CSVLink

  const [daywisereportdown, setDaywisereportdown] = useState([]);
  const [daywisereportcamp, setDaywisereportcamp] = useState({});
  const [showActionsMenu, setShowActionsMenu] = useState(-1);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [reportType, setReportType] = useState((localStorage.getItem("role") === roles.advertiser || localStorage.getItem("role") === roles.salesperson) ? "campaign" : "consolidated");
  const [mobileNumbers, setMobileNumbers] = useState("");
  const [whatsappLoader, setWhatsappLoader] = useState(false);
  const [sendClicked, setSendClicked] = useState(false);
  const [newReports, setNewReports] = useState(false);
  const [positionwiseImp, setPositionwiseImp] = useState(false);
  const [currentTeam , setCurrentTeam] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  const handleWhatsapp = (e) => {
    if (e.detail.source === "overlay") {
      e.preventDefault();
    } else {
      setShowWhatsapp(false);
      reset();
    }
  };
  
  const getSales = async () => {
    try {
      let res = await api({
        url: "/user/sales_persons/getsales",
        method: "GET",
        responseType: "json",
      });
      setSaleslist(res.data);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const getCategory = async () => {
    try {
      let res = await api({
        url: "/user/campaign/name",
        method: "GET",
        responseType: "json",
      });
      setCampCategory(res.data);
    } catch (error) {
      if (error.response.status === 401) navigate("/");
    }
  };
  const getAdv = async () => {
    try {
      let res = await api({
        url: "/user/advertisers/getadv",
        method: "POST",
        responseType: "json",
      });
      setAdvlist(res.data.result3);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const getDept = async () => {
    try {
      let res = await api({
        url: "/user/sales_persons/department",
        method: "POST",
        responseType: "json",
        data: {},
      });
      setDepartment(res.data);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  async function fetchCreativeNames(item) {
    try {
      const item_res = await api({
        url: "/user/campaign_creation/creative_Names",
        method: "POST",
        responseType: "json",
        data: {
          ids: item.creative_ids,
          campaign_id: item.campaign_id,
          type: item.type,
        },
      });
      return item_res.data;
    } catch (err) {
      console.error("Error fetching creative names:", err);
      throw err; // Rethrow the error to handle it later if needed
    }
  }

  const getCreativeNames = async (ids, campaign_id, type, grouped) => {
    try {
      let res = await api({
        url: "/user/campaign_creation/creative_Names",
        method: "POST",
        responseType: "json",
        data: { ids, campaign_id, type },
      });
      if (grouped) {
        let group_creative_details_data = await api({
          url: "/user/campaign_creation/getGroupCampCreatives",
          method: "POST",
          responseType: "json",
          data: { campaign_id },
        });
        let temp_creatives = [];
        temp_creatives = temp_creatives.concat(res.data);
        try {
          const promises =
            group_creative_details_data?.data?.map(fetchCreativeNames);
          let results = await Promise.all(promises);
          results = results.flat();
          temp_creatives = temp_creatives.concat(results); // Concatenate the arrays of creative names

          setCreative_Names(temp_creatives);
        } catch (err) {
          console.error("Error processing creative details:", err);
        }
      } else {
        setCreative_Names(res.data);
      }
    } catch (error) {
      if (error.response.status === 401) navigate("/");
    }
  };
  const fun = (id, dept) => {
    if (dept === "sales") {
      for (let i = 0; i < saleslist.length; i++) {
        if (saleslist[i].value === id) {
          return saleslist[i].label;
        }
      }
      return "NULL";
    }
    if (dept === "advertiser") {
      for (let i = 0; i < advlist.length; i++) {
        if (advlist[i].value === id) {
          return advlist[i].label;
        }
      }
      return "NULL";
    }
    if (dept === "category") {
      for (let i = 0; i < campCategory.length; i++) {
        if (campCategory[i].value === id) {
          return campCategory[i].label;
        }
      }
      return "NULL";
    }
    if (dept === "ops") {
      for (let i = 0; i < opsName.length; i++) {
        if (opsName[i].user_id === id) return opsName[i].user_name;
      }
      return "NULL";
    }

    if (dept === "depart") {
      for (let i = 0; i < deptlist.length; i++) {
        if (deptlist[i].value === id) {
          return deptlist[i].label;
        }
      }
      return "NULL";
    }
  };
  const handleDate = (item) => {
    let list = [...timeslots];
    item?.map((d1, index) => {
      return (
        <p key={index}>
          {(list = [...list, { sdate: "", edate: "" }])}
          {(list[index]["sdate"] = formatDateWithTime(d1.sdate))}
          {(list[index]["edate"] = formatDateWithTime(d1.edate))}
        </p>
      );
    });
    timeslots = [...list];
  };
  const result1 = {
    datavariable: [],
    type: "",
    action: "",
    id: "",
    start: {
      advertiser_id: "",
      campaign_name: "",
      sales_name: "",
      ro_number: "",
      type: "",
      category_id: 0,
      campaign_type: "",
      brand: "",
    },
    budget: {
      total_budget: 0,
      daily_budget: 0,
      cpm: 0,
      tot_imp_cap: 0,
      tot_click_cap: 0,
      daily_imp_cap: 0,
      cpd: 0,
      daily_click_cap: 0,
      cpc_price: 0,
    },
    creatselect: {
      creative_ids: [],
      position: 0,
      positiontype: "",
      frequency_cap: 0,
      ad_code: "",
      line_item_code: "",
      creative_type: "",
      frequency_cap_type: "",
      discount: 0,
      post_type: "",
      news_type: "",
      packages: "",
    },
    date: {
      start_date: "",
      end_date: "",
      datelist: [{ sdate: "", edate: "" }],
    },
    target: {
      target_id: 0,
      locations: [],
      lang_ids: [],
      os: "",
      app: [],
      minspend: [],
    },
  };

  // async function convertHtmlToImage(htmlContent, outputPath) {
  //   const browser = await puppeteer.launch();
  //   const page = await browser.newPage();

  //   // Set the viewport size if needed
  //   await page.setViewport({ width: 800, height: 600 });

  //   await page.setContent(htmlContent);

  //   // Capture screenshot of the element with class 'report-image'
  //   const reportImageElement = await page.$('.report-image');
  //   if (reportImageElement) {
  //     await reportImageElement.screenshot({ path: outputPath });
  //     console.log('Image captured successfully:', outputPath);
  //   } else {
  //     console.error('Error: Element with class "report-image" not found.');
  //   }

  //   await browser.close();
  // }

  const editAction = (index, id) => {
    // result1.datavariable = JSON.parse(JSON.stringify(data))
    result1.id = id;
    result1.type = data[index].type;
    result1.start.company_name = data[index].company_name;
    result1.start.department = data[index].department_id;
    result1.start.advertiser_id = data[index].advertiser_id;
    result1.start.campaign_name = data[index].campaign_name;
    result1.start.sales_id = data[index].sales_id;
    result1.start.category_id = data[index].category_id;
    result1.start.ro_number = data[index].ro_number;
    result1.start.type = data[index].type;
    result1.start.brand = data[index].brand;
    result1.start.campaign_type = data[index].campaign_type;
    result1.budget.total_budget = data[index].total_budget;
    result1.budget.daily_budget = data[index].daily_budget;
    result1.budget.cpm = data[index].cpm;
    result1.budget.tot_imp_cap = data[index].tot_imp_cap;
    result1.budget.tot_click_cap = data[index].tot_click_cap;
    result1.budget.daily_imp_cap = data[index].daily_imp_cap;
    result1.budget.daily_click_cap = data[index].daily_click_cap;
    result1.creatselect.cpd = data[index].cpd;
    result1.budget.cpc_price = data[index].cpc_price;
    result1.budget.payment = data[index].payment;
    result1.creatselect.position = data[index].position;
    result1.creatselect.creative_type = data[index].creative_type;
    result1.creatselect.positiontype = data[index].position_type;
    result1.creatselect.frequency_cap_type = data[index].frequency_cap_type;
    result1.creatselect.frequency_cap = data[index].frequecy_cap;
    result1.creatselect.ad_code = data[index].ad_code;
    result1.creatselect.line_item_code = data[index].line_item_code;
    result1.creatselect.post_type = data[index].post_type;
    result1.creatselect.news_type = data[index].news_type;
    result1.creatselect.creative_ids = data[index].creative_ids;
    result1.creatselect.discount = data[index].discount;
    result1.creatselect.packages = data[index].package;
    result1.creatselect.action_type = data[index].action_type;
    result1.date.end_date = data[index].end_date;
    result1.date.start_date = data[index].start_date;
    let dtime = data[index].day_time_slots;
    result1.date.datelist = dtime;

    getTarget(id, data[index].grouped);
  };
  const fun1 = (type) => {
    switch (type) {
      case 0:
        return "Postpaid";
      case 1:
        return "Prepaid";
      default:
        return "";
    }
  };
  const fun2 = (mode) => {
    switch (mode) {
      case 1:
        return "Checknumber";
      case 2:
        return "UPI";
      case 3:
        return "Banktransfer";
      case 4:
        return "OnlineTransaction ID";
      default:
        return "";
    }
  };
  useEffect(() => {
    if (SALES !== "" && !initialRender) {
      getData();
      // downloadReport()
    }
  }, [SALES]);
  let target = {};
  const getData = async (
    search = "",
    page = 0,
    status = -1,
    dateFilter,
    campaignType = "all",
    x_filter = 0,
    target_filter = {
      lang_id: -1,
      state_id: -1,
      district_id: -1,
      mandal_id: -1,
    }
  ) => {
    setShowActionsMenu(-1);
    try {
      setLoader(true);
      let res = await api({
        url: "/user/campaign_creation/get",
        method: "POST",
        responseType: "json",
        data: {
          search,
          page,
          status,
          dateFilter: Headdate,
          campaignType,
          x_filter,
          limit: config.PER_PAGE,
          flag: "report",
          target_filter,
          sales_ops:
            SALES === "" ? { index: 0, type: "user", value: 0 } : SALES,
        },
      });
      if (res.code === 200) {
        setData(res.data.data);
        setTotalPages(Math.ceil(parseInt(res.data.total) / config.PER_PAGE));
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const downloadReport = async (
    search = "",
    page = 0,
    status = -1,
    dateFilter,
    campaignType = "all",
    x_filter = 0,
    target_filter = {
      lang_id: -1,
      state_id: -1,
      district_id: -1,
      mandal_id: -1,
    }
  ) => {
    setDownloadLoader(true);
    try {
      let res2 = await api({
        url: "/user/campaign_creation/get",
        method: "POST",
        responseType: "json",
        data: {
          search,
          page,
          status,
          dateFilter: Headdate,
          campaignType,
          x_filter,
          limit: 0,
          flag: "report_download",
          target_filter,
          sales_ops:
            SALES === "" ? { index: 0, type: "user", value: 0 } : SALES,
        },
      });
      if (res2.code === 200) {
        setDownloadLoader(false);
        setDownloadData(res2.data.data);
      }
    } catch (error) {
      setDownloadLoader(false);
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  useEffect(() => {
    if (downloadData.length) {
      csvLinkRef?.current?.link?.click();
      setDownloadData([]);
    }
  }, [downloadData]);

  const downloadDayWiseReports = async (camp) => {
    setDaywisereportcamp({});
    try {
      const daywiseresult = await api({
        url: "/reports/daywisereportsdownload",
        method: "POST",
        responseType: "json",
        data: {
          campid: camp.campaign_id,
          grouped: camp.grouped,
          x_value: camp.x_value,
        },
      });

      if (daywiseresult.code === 200) {
        setDaywisereportcamp(camp);
        setDaywisereportdown(daywiseresult.data.totalres);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  useEffect(() => {
    if (daywisereportdown.length) {
      downloadcsvLinkRef?.current?.link?.click();
      setDaywisereportcamp({});
      setDaywisereportdown([]);
    }
  }, [daywisereportdown]);

  // const removeCommonLocation = (
  //   lang_ids,
  //   state_ids,
  //   district_ids,
  //   mandal_ids,
  //   village_ids,
  //   exclude
  // ) => {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       let mandalRes = [],
  //         districtRes = [],
  //         statesRes = [],
  //         villageRes = [],
  //         mandaldum = [],
  //         districtdum = [],
  //         statedum = [],
  //         langdum = [];
  //       let ex_villages = [],
  //         ex_mandals = [],
  //         ex_districts = [],
  //         states = [],
  //         mandalsinlist = [],
  //         districtinlist = [],
  //         statesinlist = [],
  //         villagesinlist = [];
  //       if (mandal_ids.length)
  //         mandalsinlist = mandal_ids.map((j) => +j.mandal_id);
  //       if (district_ids.length)
  //         districtinlist = district_ids.map((j) => +j.dist_id);
  //       if (state_ids.length) statesinlist = state_ids.map((j) => +j.state_id);
  //       if (village_ids.length)
  //         villagesinlist = village_ids.map((j) => +j.village_id);
  //       if (village_ids.length)
  //         mandaldum = village_ids.map((j) => +j.mandal_id);
  //       if (mandal_ids.length) districtdum = mandal_ids.map((j) => +j.dist_id);
  //       if (district_ids) statedum = district_ids.map((j) => +j.state_id);
  //       if (state_ids) langdum = state_ids.map((j) => +j.lang_id);
  //       // console.log(villageRes, "{{{{{{{{{{{{{{{{{{{{", village_ids.map(j => +j.village_id), lang_ids, state_ids, district_ids, mandal_ids, village_ids, "++++++++++++++")
  //       if (exclude) {
  //         if (village_ids.length) {
  //           ex_villages = villagesinlist;
  //           mandalRes = mandaldum;
  //           villageRes = [];
  //         }
  //         if (mandal_ids.length) {
  //           ex_mandals = mandalsinlist.filter(
  //             (item) => !mandaldum.includes(item)
  //           );
  //           districtRes = [];
  //           mandal_ids.map((item) => {
  //             if (ex_mandals.includes(item.mandal_id))
  //               districtRes.push(+item.dist_id);
  //           });
  //         }
  //         if (district_ids.length) {
  //           ex_districts = districtinlist.filter(
  //             (item) => !districtdum.includes(+item)
  //           );
  //           // statesRes = []
  //           // district_ids.map((item) => { if (ex_districts.includes(+item.dist_id)) statesRes.push(+item.state_id) })
  //           // statesRes = [...new Set([...statesRes,...statesinlist])]
  //         }
  //         statesRes = statesinlist;
  //       } else {
  //         villageRes = villagesinlist;
  //         statesRes = statesinlist.filter((item) => !statedum.includes(item));
  //         mandalRes = mandalsinlist.filter((item) => !mandaldum.includes(item));
  //         districtRes = districtinlist.filter(
  //           (item) => !districtdum.includes(item)
  //         );
  //       }
  //       lang_ids = lang_ids.filter((item) => !langdum.includes(item));

  //       statesRes = Array.from(new Set(statesRes));
  //       districtRes = Array.from(new Set(districtRes));
  //       mandalRes = Array.from(new Set(mandalRes));
  //       villageRes = Array.from(new Set(villageRes));
  //       ex_districts = Array.from(new Set(ex_districts));
  //       ex_mandals = Array.from(new Set(ex_mandals));
  //       ex_villages = Array.from(new Set(ex_villages));
  //       // if (village_ids.length)
  //       //   villages = village_ids.filter(item => !mandalRes.includes(+item.mandal_id)).map(item => +item.village_id);
  //       // if (mandal_ids.length)
  //       //   mandals = mandal_ids.filter(item => !districtRes.includes(+item.dist_id)).map(item => +item.mandal_id);
  //       // if (district_ids.length)
  //       //   districts = district_ids.filter(item => !statesRes.includes(+item.state_id)).map(item => +item.dist_id);
  //       // if (state_ids.length)
  //       //   states = state_ids.filter(item => {
  //       //     if (lang_ids.includes(+item.lang_id)) {
  //       //       let index = lang_ids.findIndex(j => j === +item.lang_id);
  //       //       lang_ids.splice(index, 1)
  //       //       return true
  //       //     }
  //       //     return false
  //       //   }).map(j => +j.state_id);
  //       return resolve({
  //         lang_ids,
  //         state_ids: statesRes,
  //         district_ids: districtRes,
  //         mandal_ids: mandalRes,
  //         village_ids: villageRes,
  //         ex_villages,
  //         ex_mandals,
  //         ex_districts,
  //       });
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   });
  // };
  const view = (item) => {
    setFormshow(true);
    setcampaigndetails(item);
  };
  const get_day_report = async (id) => {
    let res = await api({
      url: "/reports/getreports",
      method: "POST",
      responseType: "json",
      data: {
        id,
      },
    });
  };
  const fun3 = (type) => {
    switch (type) {
      case 1:
        return "Created";
      case 2:
        return "Running";
      case 3:
        return "Paused";
      case 4:
        return "Completed";
      default:
        return "Scheduled";
    }
  };
  const handlePageClick = (event) => {
    if (startDateFormatted && endDateFormatted) {
      setCurrentPage(event.selected);
      getData(
        search,
        event.selected,
        status,
        { startDateFormatted, endDateFormatted },
        campaignType,
        x_filter,
        target_filter
      );
      // downloadReport(search, 0, status, { startDateFormatted, endDateFormatted }, campaignType, x_filter, target_filter);
    } else {
      setCurrentPage(event.selected);
      getData(
        search,
        event.selected,
        status,
        dateFilter,
        campaignType,
        x_filter,
        target_filter
      );
      // downloadReport(search, 0, status, dateFilter, campaignType, x_filter, target_filter)
    }
  };

  const searchData = (e) => {
    if (startDateFormatted && endDateFormatted) {
      setSearch(e.target.value);
      setCurrentPage(0);
      getData(
        e.target.value,
        0,
        status,
        { startDateFormatted, endDateFormatted },
        campaignType,
        x_filter,
        target_filter
      );
      // downloadReport(e.target.value, 0, status, { startDateFormatted, endDateFormatted }, campaignType, x_filter, target_filter)
    } else {
      setSearch(e.target.value);
      setCurrentPage(0);
      getData(
        e.target.value,
        0,
        status,
        dateFilter,
        campaignType,
        x_filter,
        target_filter
      );
      // downloadReport(e.target.value, 0, status, dateFilter, campaignType, x_filter, target_filter)
    }
  };

  useEffect(() => {
    Header();
  }, [HeaderSearch]);

  useEffect(() => {
    if (!initialRender) getData();
  }, [Headdate]);

  // const changeDateHandler = () => {
  //   if (!initialRender) {
  //     if (Headdate.startDate !== null) {
  //       setStartDateFormatted(AsiaDateFormat(Headdate.startDate));
  //       setEndDateFormatted(AsiaDateFormat(Headdate.endDate));
  //       setCurrentPage(0)
  //     }
  //   }
  // }

  const Header = () => {
    if (!initialRender) {
      if (startDateFormatted && endDateFormatted) {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        getData(
          HeaderSearch,
          0,
          status,
          { startDateFormatted, endDateFormatted },
          campaignType,
          x_filter,
          target_filter
        );
        // downloadReport(HeaderSearch, 0, status, { startDateFormatted, endDateFormatted }, campaignType, x_filter, target_filter)
      } else {
        setSearch(HeaderSearch);
        setCurrentPage(0);
        getData(
          HeaderSearch,
          0,
          status,
          dateFilter,
          campaignType,
          x_filter,
          target_filter
        );
        // downloadReport(HeaderSearch, 0, status, dateFilter, campaignType, x_filter, target_filter)
      }
    }
  };

  const typeFilterChange = (e) => {
    if (startDateFormatted && endDateFormatted) {
      setCampaignType(e.target.value);
      setCurrentPage(0);
      getData(
        search,
        0,
        status,
        { startDateFormatted, endDateFormatted },
        e.target.value,
        x_filter,
        target_filter
      );
      // downloadReport(search, 0, status, { startDateFormatted, endDateFormatted }, e.target.value, x_filter, target_filter)
    } else {
      setCampaignType(e.target.value);
      setCurrentPage(0);
      getData(
        search,
        0,
        status,
        dateFilter,
        e.target.value,
        x_filter,
        target_filter
      );
      // downloadReport(search, 0, status, dateFilter, e.target.value, x_filter, target_filter)
    }
  };

  const xFilterChange = (e) => {
    if (startDateFormatted && endDateFormatted) {
      setX_filter(e.target.value);
      setCurrentPage(0);
      getData(
        search,
        0,
        status,
        { startDateFormatted, endDateFormatted },
        campaignType,
        e.target.value,
        target_filter
      );
      // downloadReport(search, 0, status, { startDateFormatted, endDateFormatted }, campaignType, e.target.value, target_filter)
    } else {
      setX_filter(e.target.value);
      setCurrentPage(0);
      getData(
        search,
        0,
        status,
        dateFilter,
        campaignType,
        e.target.value,
        target_filter
      );
      // downloadReport(search, 0, status, dateFilter, campaignType, e.target.value, target_filter)
    }
  };

  const LanguageFilterChange = (e) => {
    setLangFilter(e.target.value);
    setDistrictfilter([]);
    setMandalfilter([]);
    setCurrentPage(0);
    setTarget_filter({
      lang_id: e.target.value,
      state_id: -1,
      district_id: -1,
      mandal_id: -1,
    });
    getData(search, 0, status, dateFilter, campaignType, x_filter, {
      lang_id: e.target.value,
      state_id: -1,
      district_id: -1,
      mandal_id: -1,
    });
    // downloadReport(search, 0, status, dateFilter, campaignType, x_filter, { lang_id: e.target.value, state_id: -1, district_id: -1, mandal_id: -1 })
    if (parseInt(e.target.value) === -1) {
      setStatefilter(-1);
      // setLangFilter(-1)
      setSelectdistrict(-1);
    }
  };

  const StateFilterChange = async (value) => {
    setStatefilter(value);
    setMandalfilter([]);
    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [value], langs: [langfilter] },
        });
        let districts = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.dist_name}` };
          districts.push(temp);
        }
        setDistrictfilter(districts);
        setTarget_filter({
          lang_id: target_filter.lang_id,
          state_id: value,
          district_id: -1,
          mandal_id: -1,
        });
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict(-1);
      setStatefilter(-1);
    }
    getData(search, 0, status, dateFilter, campaignType, x_filter, {
      lang_id: target_filter.lang_id,
      state_id: value,
      district_id: -1,
      mandal_id: -1,
    });
    // downloadReport(search, 0, status, dateFilter, campaignType, x_filter, { lang_id: target_filter.lang_id, state_id: value, district_id: -1, mandal_id: -1 })
  };

  const DistrictFilterChanger = async (value) => {
    setSelectdistrict(value);
    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getMandalsnew",
          method: "POST",
          responseType: "json",
          data: { districts: [value], langs: [langfilter] },
        });
        let mandals = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.mandal_name}` };
          mandals.push(temp);
        }
        setMandalfilter(mandals);
        setTarget_filter({
          district_id: value,
          mandal_id: -1,
          state_id: target_filter.state_id,
          lang_id: target_filter.lang_id,
        });
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict(-1);
    }
    getData(search, 0, status, dateFilter, campaignType, x_filter, {
      district_id: value,
      mandal_id: -1,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
    });
    // downloadReport(search, 0, status, dateFilter, campaignType, x_filter, { district_id: value, mandal_id: -1, state_id: target_filter.state_id, lang_id: target_filter.lang_id })
  };

  const MandalFilterChange = async (value) => {
    setTarget_filter({ ...target_filter, mandal_id: value });
    getData(search, 0, status, dateFilter, campaignType, x_filter, {
      ...target_filter,
      mandal_id: value,
    });
    // downloadReport(search, 0, status, dateFilter, campaignType, x_filter, { ...target_filter, mandal_id: value })
  };

  const statusFilterChange = (e) => {
    if (startDateFormatted && endDateFormatted) {
      setStatus(e.target.value);
      setCurrentPage(0);
      getData(
        search,
        0,
        e.target.value,
        { startDateFormatted, endDateFormatted },
        campaignType,
        x_filter,
        target_filter
      );
      // downloadReport(search, 0, e.target.value, { startDateFormatted, endDateFormatted }, campaignType, x_filter, target_filter)
    } else {
      setStatus(e.target.value);
      setCurrentPage(0);
      getData(
        search,
        0,
        e.target.value,
        dateFilter,
        campaignType,
        x_filter,
        target_filter
      );
      // downloadReport(search, 0, e.target.value, dateFilter, campaignType, x_filter, target_filter)
    }
  };

  // const dateFilterChange = (e) => {
  //   setDateFilter(e.target.value);
  //   setCurrentPage(0);
  //   getData(search, 0, status, e.target.value, campaignType);
  // }

  const dateRangeChange = (dates) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
    let startFormatted = moment(dates[0]).tz("Asia/Kolkata").format();
    let endFormatted = moment(dates[1]).tz("Asia/Kolkata").format();
    setStartDateFormatted(startFormatted);
    setEndDateFormatted(endFormatted);
    setCurrentPage(0);
  };

  let csvHeaders = [
    { label: "Campaign Name", key: "campaign_name" },
    { label: " Campaign Type", key: "campaign_type" },
    { label: "Start Date", key: "start_date" },
    { label: "End Date", key: "end_date" },
    { label: "Position", key: "position" },
    { label: "Total Budget", key: "total_budget" },
    { label: "Daily Budget", key: "daily_budget" },
  ];
  // { label: 'CTR(%)', key: 'ctr_percent' },
  // { label: 'ECPM/CPD', key: 'ecpm_cpd' },
  if (
    localStorage.getItem("role") !== roles.advertiser &&
    localStorage.getItem("role") !== roles.salesperson
  ) {
    csvHeaders.push({ label: "CTR(%)", key: "ctr_percent" });
    csvHeaders.push({ label: "ECPM/CPD", key: "ecpm_cpd" });
    csvHeaders.push({ label: "Location", key: "location" });
    csvHeaders.push({ label: "Sales Person", key: "sales_name" });
    csvHeaders.push({ label: "Impressions", key: "total_imp" });
    csvHeaders.push({ label: "Clicks", key: "total_click" });
    csvHeaders.push({ label: "Shares", key: "shares" });
    csvHeaders.push({ label: "Team", key: "team" });
    csvHeaders.push({ label: "Creative Type", key: "creative_type" });
    // csvHeaders.push({ label: 'Adv CTR(%)	', key: 'adv_ctr' })
  } else {
    csvHeaders.push({ label: "Audience Viewed", key: "total_imp" });
    csvHeaders.push({ label: "Audience Engaged", key: "total_click" });
  }
  csvHeaders.push({ label: "Spent", key: "spent" });
  csvHeaders.push({ label: "Status", key: "status" });
  csvHeaders.push({ label: "Target", key: "target" });

  let DWDHeaders = [{ label: "Date", key: "date" }];
  if (
    localStorage.getItem("role") === roles.advertiser ||
    localStorage.getItem("role") === roles.salesperson
  ) {
    DWDHeaders.push({ label: "Audience Viewed", key: "total_imp" });
    DWDHeaders.push({ label: "Audience Engaged", key: "total_click" });
  } else {
    DWDHeaders.push({ label: "Impressions", key: "total_imp" });
    DWDHeaders.push({ label: "Clicks", key: "total_click" });
    DWDHeaders.push({ label: "Advertiser Impressions", key: "adv_total_imp" });
    DWDHeaders.push({ label: "Advertiser Clicks", key: "adv_total_click" });
    DWDHeaders.push({ label: "CTR(%)", key: "ctr" });
    DWDHeaders.push({ label: "ECPM", key: "ecpm" });
    DWDHeaders.push({ label: "Advertiser Spent", key: "adv_spent" });
    DWDHeaders.push({ label: "Location", key: "location" });
    DWDHeaders.push({ label: "Sales Person", key: "sales_name" });
    DWDHeaders.push({ label: "Team", key: "team" });
    DWDHeaders.push({ label: "Creative Type", key: "creative_type" });
  }
  DWDHeaders.push({ label: "Spent", key: "spent" });

  useEffect(() => {
    if (startDateFormatted && endDateFormatted !== "Invalid date") {
      getData(
        search,
        0,
        status,
        { startDateFormatted, endDateFormatted },
        campaignType,
        x_filter,
        target_filter
      );
      // downloadReport(search, 0, status, { startDateFormatted, endDateFormatted }, campaignType, x_filter, target_filter)
    }
  }, [endDateFormatted]);

  const getTarget = async (campaign_id, grouped) => {
    try {
      let res = await api({
        url: "/user/target/getTarget",
        method: "POST",
        responseType: "json",
        data: { campaign_id: campaign_id },
      });
      setactual_target(
        await removeCommonLocation(
          res.data.lang_ids,
          res.data.state_ids,
          res.data.district_ids,
          res.data.mandal_ids,
          res.data.village_ids,
          res.data.exclude
        )
      );
      setTargetdetails(res.data);
      result1.target.state_ids = res.data.state_ids;
      result1.target.district_ids = res.data.district_ids;
      result1.target.mandal_ids = res.data.mandal_ids;
      result1.target.village_ids = res.data.village_ids;
      result1.target.lang_ids = res.data.lang_ids;
      result1.target.os = res.data.os;
      result1.target.minspend = res.data.minspend;
      result1.target.app = res.data.app_category;
      result1.target.min_age =
        res.data.age.min === "" ? "" : parseInt(res.data.age.min);
      result1.target.max_age =
        res.data.age.max === "" ? "" : parseInt(res.data.age.max);
      result1.target.gender = res.data.gender;
      result1.target.target_id = res.data.target_id;
      result1.target.exclude = res.data.exclude;
      if (grouped) {
        try {
          const group_targets_data = await api({
            url: `/user/target/getGroupTarget`,
            method: "POST",
            responseType: "json",
            data: { campaign_id: campaign_id },
          });
          const group_targets = group_targets_data?.data;
          if (group_targets?.length) {
            let temp_group_target_ids = [];
            try {
              const promises = group_targets.map(processTargetItem);
              const results = await Promise.all(promises);
              setGroup_target_Actual_ids(results);
              setGroup_target_dataArray(group_targets);
            } catch (err) {
              console.error("Error processing group targets:", err);
            }
          }
        } catch (error) {
          console.error("Error @ getGroupTarget", error);
        }
      }
      setPreview(result1);
    } catch (erre) {
      console.error(erre);
    }
  };

  async function processTargetItem(item) {
    try {
      const temp_target = await removeCommonLocation(
        item.lang_ids,
        item.state_ids,
        item.district_ids,
        item.mandal_ids,
        item.village_ids,
        item.exclude
      );
      return temp_target;
    } catch (err) {
      console.error("Error processing target item:", err);
      throw err; // Rethrow the error to handle it later if needed
    }
  }

  const handleTabActivate = (event) => {
    setTab(event.detail.name);
  };

  const MergeGroupedCampaigns = async (group_id) => {
    let newData = JSON.parse(
      JSON.stringify(data.filter((item) => item.sub_group_item === undefined))
    );
    setData(newData);
    // console.log(index)
    if (group_id === group_index) {
      setData(newData);
      setGroup_index(-1);
      return;
    }
    setGroup_index(-1);
    setGroup_index(group_id);
    let sub_group_data = await api({
      url: `/user/campaign_creation/subGroupData`,
      method: "POST",
      responseType: "json",
      data: { group_id },
    });
    let MergedDataWithGroup = [];
    newData.map((item, item_index) => {
      MergedDataWithGroup.push(item);
      if (item.group_id === group_id && sub_group_data.data?.length)
        MergedDataWithGroup = MergedDataWithGroup.concat(sub_group_data.data);
    });
    setData(MergedDataWithGroup);
  };

  const navigate = useNavigate();
  useEffect(() => {
    getData();
    // downloadReport();
    setInitialRender(false);
  }, []);

  const options = [
    { value: "campaign", label: "Campaignwise Reports" },
    { value: "consolidated", label: "Consolidated Reports Local" },
    { value: "ecpm", label: "ECPM Reports Local" },
    { value: "teamwise", label: "Teamwise Reports Local" },
    { value: "salesPerson", label: "Sales Person Reports" },
    { value: "comparison", label: "Comparison Reports Local" },
    { value: "teamwiseNational", label: "Teamwise Reports National" },
    { value: "consolidatedNational", label: "Consolidated Reports National" },
    {value: "alpha", label:"Alpha Reports" },
    {value: "9",label:"Centralized Inbound sales"},
    {value: "2",label:"Centralized Local sales"},
    {value: "3",label:"Centralized Metro sales"},
    {value: "5", label:"Centralized Alpha sales"},
    {value:"package_ad_report",label:"Package Ad Report"},
    {value:"finance_report",label:"Finance Report"},
  ];

  const Months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  const years = [];

  for (let i = 2022; i <= new Date().getFullYear(); i++) {
    years.push({ value: i, label: i });
  }

  const sendWhatsappMessage = async () => {
    try {
      setSendClicked(true);
      let res = await api({
        url: "reports/whatsapp",
        method: "POST",
        responseType: "json",
        data: {
          mobileNumbers,
          imageURL: reportImageUrl,
        },
      });
      if (res.code === 200) {
        reset();
        Toast("success", "Message Delivered Successfully");
      }
      setSendClicked(false);
    } catch (error) {
      setSendClicked(false);
      console.error(error);
    }
  };
  function getDaysInMonth(year, month) {
    const thisYear = new Date().getFullYear()
    const thisMonth = new Date().getMonth()
    if(thisYear === parseInt(year) && thisMonth === parseInt(month))
    return new Date().getDate()
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
    return lastDayOfMonth;
  }
const sendWhatsAppReports = async () => {
  if(!currentTeam){
    Toast("warning","Please select a team")
    return;
  }
  try {
    let res = await api({
      url: "/whatsapp/sendteamwisereports",
      method: "POST",
      responseType: "json",
      data: {
        team:currentTeam,
        newReport:newReports,
        month:month,
        year:year,
        currentDay:getDaysInMonth(year,month),

      },
    });
  if(res.code === 200){
    Toast("success","Message Delivered Successfully")
  }
  } catch (error) {
    console.error(error);
  }
}


  const handleDownloadPreview = () => {
    const previewElement = document.querySelector(".report-image");
    toBlob(previewElement).then(function (blob) {
      setReportImage(blob);
    });
  };
  const formData = new FormData();
  formData.append("files", reportImage);
  const imageUrl = async () => {
    try {
      let url = await api({
        url: `/upload/reportsImage`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(url);
      if (url.code === 200) {
        setReportImageUrl(url?.data?.data);
        setWhatsappLoader(false);
        setShowWhatsapp(true);
        Toast("success", "Image uploaded Successfully");
      } else {
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };
  useEffect(() => {
    if (reportImage) {
      imageUrl();
    }
  }, [reportImage]);

  // console.log(month, year, typeof month, typeof year);

  return (
    <>
      {(localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) ? (<SlTabGroup className="mb-3">
        <SlTab
          onClick={() => {
            setNewReports(false);
            setPositionwiseImp(false);
            setReportType((localStorage.getItem("role") === roles.advertiser || localStorage.getItem("role") === roles.salesperson) ? "campaign" : "consolidated")
          }}
          slot="nav"
          panel="general"
        >
            Old
          </SlTab>
       {reportType !== "campaign" &&(
          <SlTab
            onClick={() => {
              setNewReports(true);
              setPositionwiseImp(false);
              setReportType((localStorage.getItem("role") === roles.advertiser || localStorage.getItem("role") === roles.salesperson) ? "campaign" : "consolidated")
            }}
            slot="nav"
            panel="all"
          >
            New          </SlTab>
        )}
        {/* <SlTab
          onClick={() => {
            setPositionwiseImp(true);
            setReportType("positionwise_impressions")
          }}
          slot="nav"
        >
          Positionwise Impressions
        </SlTab> */}
      </SlTabGroup>) : null}
      {reportType !== "positionwise_impressions" ? (<div className="d-flex gap-5">
        <div>
          {(localStorage.getItem("role") !== roles.advertiser) ? <h5>Select Reports Type</h5> : null}
          <SlSelect
  className="my-5 w-100"
  value={reportType}
  onSlChange={(e) => setReportType(e.target.value)}
>
  {options
    .filter(option => {
      const role = localStorage.getItem("role");
      if (role === roles.advertiser) {
        return option.value === "campaign";
      } else if (role === roles.salesperson) {
        return option.value === "salesPerson" || option.value === "campaign";
      }
      else{
        return true; // Show all options for other roles
      }
    })
    .map((item, index) => (
      <SlOption key={index} value={item.value}>
        {item.label}
      </SlOption>
    ))}
</SlSelect>

        </div>
        {reportType !== "campaign" && reportType !=="inbound" && reportType !=="localsales" && reportType !=="metro" && reportType!== "alpha_Sales" && reportType !== "package_ad_report" && reportType !== "finance_report" && (
          <>
            <div>
              <h5>Select Month</h5>
              <SlSelect
                className="my-5 w-100"
                value={month}
                onSlChange={(e) => {
                  setMonth(e.target.value);
                }}
              >
                {Months.map((item, index) => {
                  return <SlOption value={item.value}>{item.label}</SlOption>;
                })}
              </SlSelect>
            </div>
            <div>
              <h5>Select year</h5>
              <SlSelect
                className="my-5 w-100"
                value={year}
                onSlChange={(e) => {
                  setYear(e.target.value);
                }}
              >
                {years.map((item, index) => {
                  return <SlOption value={item.value}>{item.label}</SlOption>;
                })}
              </SlSelect>
            </div>
            {reportType !== "package_ad_report" && <div className="my-3 d-flex gap-1">
              {!whatsappLoader && (
                <img
                  onClick={() => {
                    handleDownloadPreview();
                    setWhatsappLoader(true);
                  }}
                  className="cursor-pointer"
                  src={whatsappIcon}
                  alt="WhatsappIcon"
                ></img>
              )}
              {whatsappLoader && (
                <div
                  class="spinner-border text-success my-4"
                  role="status"
                ></div>
              )}
            </div>}
            {localStorage.getItem('role') === roles.ops && reportType === 'salesPerson' && <div className="d-flex gap-2 items-center">
              <div>
                <label className="form-label">Select Team</label>
              <Select options={teams} onChange={(e) => setCurrentTeam(e.value)}></Select>
                </div>
              <SlButton variant="primary" size="small" onClick={sendWhatsAppReports}>Send</SlButton>
            </div>}
          </>
        )}
      </div>) : null}

      {reportType === "campaign" && (
        <div>
          <header class="flex items-center mb-3">
            <h5>Campaigns Report</h5>
            <aside class="flex gap-3 ml-auto">
              {/* <div>
            <SlInput
              name="search"
              id="myInput"
              size="small"
              onSlInput={debounce(searchData, 500)}
              placeholder="Search By Campaign/Advertiser/RO/Sales/Company"></SlInput>
          </div> */}
              {localStorage.getItem("role") !== roles.advertiser && (
                <div>
                  <SlSelect
                    size="small"
                    placeholder="Select Campaign Type"
                    name="campaignType"
                    onSlChange={typeFilterChange}
                  >
                    <SlIcon
                      library="lucide"
                      name="layout"
                      slot="prefix"
                    ></SlIcon>
                    <SlOption value="all">All</SlOption>
                    <SlOption value="Editorial">Editorial</SlOption>
                    <SlOption value="Local">Local</SlOption>
                    <SlOption value="DFP">DFP</SlOption>
                  </SlSelect>
                </div>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <div className="">
                  <SlSelect
                    size="small"
                    placeholder="X filter"
                    name="x_filter"
                    onSlChange={xFilterChange}
                  >
                    <SlOption value="0">All</SlOption>
                    <SlOption value="1">with X value</SlOption>
                    <SlOption value="2">without X value</SlOption>
                  </SlSelect>
                </div>
              )}
              {/* <div >
            <DatePickerright-fixed
              selectsRange
              utcOffset={0}
              placeholderText="MM/DD/YYYY - MM/DD/YYYY"
              highlightDates={startDate === "" && [new Date()]}

            />
          </div> */}
              <div>
                <SlSelect
                  size="small"
                  placeholder="Select Status"
                  name="status"
                  onSlChange={statusFilterChange}
                >
                  <SlIcon
                    library="lucide"
                    name="list-checks"
                    slot="prefix"
                  ></SlIcon>

                  <SlOption value="-1">All</SlOption>
                  {reportStatus.map((item) => {
                    return (
                      <SlOption key={item.value} value={item.value}>
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
              {localStorage.getItem("role") !== roles.advertiser && (
                <div>
                  <SlSelect
                    placeholder="Select Language"
                    name="lang"
                    size="small"
                    onSlChange={LanguageFilterChange}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {languageOptions.map((item) => {
                      return (
                        <SlOption key={item.value} value={item.value}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}
              {langfilter !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select State"
                    name="state"
                    size="small"
                    onSlChange={(e) => {
                      StateFilterChange(e.target.value);
                    }}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {stateOptions
                      .filter((item) => item.lang_id === +langfilter)
                      .map((item) => {
                        return (
                          <SlOption key={item.state_id} value={item.state_id}>
                            {item.state_name}
                          </SlOption>
                        );
                      })}
                  </SlSelect>
                </div>
              )}
              {statefilter !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select District"
                    name="district"
                    size="small"
                    onSlChange={(e) => {
                      DistrictFilterChanger(e.target.value);
                    }}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {districtfilter.map((item) => {
                      return (
                        <SlOption
                          key={item.value.dist_id}
                          value={item.value.dist_id}
                        >
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}

              {districtselect !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select Mandal"
                    name="mandal"
                    size="small"
                    onSlChange={(e) => {
                      MandalFilterChange(e.target.value);
                    }}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {mandalfilter.map((item) => {
                      return (
                        <SlOption
                          key={item.value.mandal_id}
                          value={item.value.mandal_id}
                        >
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}
              <div>
                <CSVLink
                  data={downloadData.map(
                    ({
                      campaign_name,
                      campaign_type,
                      start_date,
                      end_date,
                      position,
                      total_budget,
                      daily_budget,
                      total_imp,
                      total_click,
                      status,
                      cpd,
                      impclicks,
                      cpc_price,
                      cpm,
                      location,
                      sales_name,
                      team,
                      creative_type,
                      target,
                    }) => {
                      const startDate = formatDate(start_date);
                      const endDate = formatDate(end_date);
                      const campaign_status = fun3(status);
                      const total =
                        campaign_type === "CPD" ? cpd : total_budget;
                      const daily =
                        campaign_type === "CPD" ? cpd : daily_budget;
                      // const imps = impclicks[0]?.total_imp ? impclicks[0]?.total_imp : 0;
                      // const clicks = impclicks[0]?.total_click ? impclicks[0]?.total_click : 0;
                      // const spent = campaign_type === 'CPD' ? cpd : campaign_type === "CPC" ? (parseFloat(cpc_price) * parseFloat(impclicks[0]?.total_click ? impclicks[0]?.total_click : 0)).toFixed(2) : ((parseFloat(cpm) * parseFloat(impclicks[0]?.total_imp ? impclicks[0]?.total_imp : 0)) / 1000).toFixed(2);
                      const imps =
                        localStorage.getItem("role") !== roles.advertiser &&
                        localStorage.getItem("role") !== roles.salesperson
                          ? impclicks[0]?.total_imp
                            ? impclicks[0]?.total_imp
                            : 0
                          : parseInt(
                              impclicks[0]?.adv_total_imp
                                ? impclicks[0]?.adv_total_imp
                                : 0
                            );
                      const clicks =
                        localStorage.getItem("role") !== roles.advertiser &&
                        localStorage.getItem("role") !== roles.salesperson
                          ? impclicks[0]?.total_click
                            ? impclicks[0]?.total_click
                            : 0
                          : parseInt(
                              impclicks[0]?.adv_total_click
                                ? impclicks[0]?.adv_total_click
                                : 0
                            );
                      const shares = impclicks[0]?.shares
                        ? impclicks[0]?.shares
                        : 0;
                      const ctr =
                        impclicks[0]?.total_click > 0 &&
                        impclicks[0]?.total_imp > 0
                          ? (
                              (impclicks[0].total_click /
                                impclicks[0].total_imp) *
                              100
                            ).toFixed(2)
                          : 0;
                      const ecpm =
                        campaign_type === "CPC" &&
                        impclicks[0]?.total_click > 0 &&
                        impclicks[0]?.total_imp > 0
                          ? (
                              ((cpc_price * impclicks[0].total_click) /
                                impclicks[0].total_imp) *
                              1000
                            ).toFixed(2)
                          : campaign_type === "CPM" &&
                            impclicks[0]?.total_imp > 0
                          ? (
                              ((cpm * impclicks[0].total_imp) /
                                1000 /
                                impclicks[0].total_imp) *
                              1000
                            ).toFixed(2)
                          : campaign_type === "CPD"
                          ? cpd
                          : 0;
                      const spent =
                        localStorage.getItem("role") !== roles.advertiser &&
                        localStorage.getItem("role") !== roles.salesperson
                          ? campaign_type === "CPD"
                            ? cpd
                            : campaign_type === "CPC"
                            ? (
                                parseFloat(cpc_price) *
                                parseFloat(
                                  impclicks[0]?.total_click
                                    ? impclicks[0]?.total_click
                                    : 0
                                )
                              ).toFixed(2)
                            : (
                                (parseFloat(cpm) *
                                  parseFloat(
                                    impclicks[0]?.total_imp
                                      ? impclicks[0]?.total_imp
                                      : 0
                                  )) /
                                1000
                              ).toFixed(2)
                          : campaign_type === "CPD"
                          ? cpd
                          : campaign_type === "CPC"
                          ? (
                              parseFloat(cpc_price) *
                              parseFloat(
                                impclicks[0]?.adv_total_click
                                  ? impclicks[0]?.adv_total_click
                                  : 0
                              )
                            ).toFixed(2)
                          : (
                              (parseFloat(cpm) *
                                parseFloat(
                                  impclicks[0]?.adv_total_imp
                                    ? impclicks[0]?.adv_total_imp
                                    : 0
                                )) /
                              1000
                            ).toFixed(2);
                      let obj = {
                        campaign_name,
                        campaign_type,
                        start_date: startDate,
                        end_date: endDate,
                        position,
                        total_budget: total,
                        daily_budget: daily,
                        total_imp: imps,
                        total_click: clicks,
                        spent: spent,
                        status: campaign_status,
                      };
                      if (
                        localStorage.getItem("role") !== roles.advertiser &&
                        localStorage.getItem("role") !== roles.salesperson
                      ) {
                        obj.shares = shares;
                        obj.ctr_percent = ctr;
                        obj.ecpm_cpd = ecpm;
                        obj.location = location;
                        obj.sales_name = sales_name;
                        obj.team = team;
                        obj.creative_type = creative_type;
                      }
                      let resultTarget = "";
                      Object.keys(target).map((key) => {
                        resultTarget =
                          resultTarget + `${key} : ${target[key]} \,`;
                      });
                      obj.target = resultTarget;
                      return obj;
                    }
                  )}
                  headers={csvHeaders}
                  filename={"campaign_reports.csv"}
                  ref={csvLinkRef} // Assign the ref to the CSVLink component
                ></CSVLink>
                <CSVLink
                  data={daywisereportdown.map(
                    ({
                      adv_total_click,
                      adv_total_imp,
                      location,
                      sales_name,
                      total_click,
                      total_imp,
                      _id,
                      team,
                      creative_type,
                    }) => {
                      const date = formatDate(_id);
                      const imps =
                        localStorage.getItem("role") !== roles.advertiser &&
                        localStorage.getItem("role") !== roles.salesperson
                          ? +total_imp
                            ? +total_imp
                            : 0
                          : +adv_total_imp
                          ? +adv_total_imp
                          : 0;
                      const clicks =
                        localStorage.getItem("role") !== roles.advertiser &&
                        localStorage.getItem("role") !== roles.salesperson
                          ? +total_click
                            ? +total_click
                            : 0
                          : +adv_total_click
                          ? +adv_total_click
                          : 0;
                      const spent =
                        localStorage.getItem("role") !== roles.advertiser &&
                        localStorage.getItem("role") !== roles.salesperson
                          ? daywisereportcamp.campaign_type === "CPD"
                            ? daywisereportcamp.cpd
                            : daywisereportcamp.campaign_type === "CPC"
                            ? (
                                parseFloat(daywisereportcamp.cpc_price) *
                                parseFloat(total_click ? total_click : 0)
                              ).toFixed(2)
                            : (
                                (parseFloat(daywisereportcamp.cpm) *
                                  parseFloat(total_imp ? total_imp : 0)) /
                                1000
                              ).toFixed(2)
                          : daywisereportcamp.campaign_type === "CPD"
                          ? daywisereportcamp.cpd
                          : daywisereportcamp.campaign_type === "CPC"
                          ? (
                              parseFloat(daywisereportcamp.cpc_price) *
                              parseFloat(adv_total_click ? adv_total_click : 0)
                            ).toFixed(2)
                          : (
                              (parseFloat(daywisereportcamp.cpm) *
                                parseFloat(adv_total_imp ? adv_total_imp : 0)) /
                              1000
                            ).toFixed(2);
                      let obj = {
                        date: date,
                        total_imp: imps,
                        total_click: clicks,
                        spent: spent,
                      };
                      if (
                        localStorage.getItem("role") !== roles.advertiser &&
                        localStorage.getItem("role") !== roles.salesperson
                      ) {
                        const ecpm =
                          daywisereportcamp.campaign_type === "CPC" &&
                          total_click > 0 &&
                          total_imp > 0
                            ? (
                                ((daywisereportcamp.cpc_price * total_click) /
                                  total_imp) *
                                1000
                              ).toFixed(2)
                            : daywisereportcamp.campaign_type === "CPM" &&
                              total_imp > 0
                            ? (
                                ((daywisereportcamp.cpm * total_imp) /
                                  1000 /
                                  total_imp) *
                                1000
                              ).toFixed(2)
                            : daywisereportcamp.campaign_type === "CPD"
                            ? daywisereportcamp.cpd
                            : 0;
                        const ctr =
                          total_click > 0 && total_imp > 0
                            ? ((total_click / total_imp) * 100).toFixed(2)
                            : 0;
                        obj.ctr = ctr;
                        obj.ecpm = ecpm;
                        obj.location = location;
                        obj.sales_name = sales_name;
                        obj.adv_total_imp = adv_total_imp;
                        obj.adv_total_click = adv_total_click;
                        obj.adv_spent =
                          daywisereportcamp.campaign_type === "CPD"
                            ? daywisereportcamp.cpd
                            : daywisereportcamp.campaign_type === "CPC"
                            ? (
                                parseFloat(daywisereportcamp.cpc_price) *
                                parseFloat(
                                  adv_total_click ? adv_total_click : 0
                                )
                              ).toFixed(2)
                            : (
                                (parseFloat(daywisereportcamp.cpm) *
                                  parseFloat(
                                    adv_total_imp ? adv_total_imp : 0
                                  )) /
                                1000
                              ).toFixed(2);
                        obj.team = team;
                        obj.creative_type = creative_type;
                      }
                      return obj;
                    }
                  )}
                  headers={DWDHeaders}
                  filename={`${daywisereportcamp.campaign_name}.csv`}
                  ref={downloadcsvLinkRef} // Assign the ref to the CSVLink component
                ></CSVLink>
                {downloadLoader ? (
                  <TableLoader />
                ) : (
                  <SlTooltip content="Download Reports">
                    <SlIconButton
                      library="lucide"
                      name="download"
                      onClick={() => {
                        downloadReport(
                          search,
                          0,
                          status,
                          dateFilter,
                          campaignType,
                          x_filter,
                          target_filter
                        );
                      }}
                    ></SlIconButton>
                  </SlTooltip>
                )}
              </div>
            </aside>
          </header>
          <div className="mb-4 table-responsive">
            <ScrollContainer>
              <table className=" table table-bordered  tableNew">
                <thead className="sticky top-0">
                  <tr>
                    <th></th>
                    <th>Campaign Name</th>
                    <th>POS</th>
                    {(localStorage.getItem("role") === roles.ops ||
                      localStorage.getItem("role") === roles.financer) && (
                      <th>PRIO</th>
                    )}
                    <th className="th-width w100px">Daily/Total Budget</th>
                    <th className="th-width w100px">Daily/Total Cap</th>
                    <th className="th-width w100px">
                      {localStorage.getItem("role") === roles.advertiser
                        ? "Audience Engaged/ Viewed"
                        : localStorage.getItem("role" === roles.salesperson)
                        ? "Clicks/Imp"
                        : "Clicks/Imp"}
                    </th>
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <th className="th-width w100px">CTR(%)/ (ECPM/CPD)</th>
                      )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <th
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Advertiser Imps"
                          className="th-width w100px"
                        >
                          Adv Clicks/Imp
                        </th>
                      )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <th className="th-width w100px">
                          Adv CTR(%)/ (ECPM/CPD)
                        </th>
                      )}
                    <th className="th-width w100px">
                      {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson
                        ? "Total/Adv Spent"
                        : "Total Spent"}
                    </th>
                    {localStorage.getItem("role") === roles.ops && (
                      <th className="th-width w100px">E Imp/Adv Imp</th>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <th>Actual Clicks</th>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <th>Shares</th>
                    )}
                    {(localStorage.getItem("role") === roles.ops ||
                      localStorage.getItem("role") === roles.financer) && (
                      <th width="80px">X value</th>
                    )}
                    <th>Payment Status</th>
                    <th style={{ width: "40px" }}></th>
                  </tr>
                </thead>
                {data?.length && !loader ? (
                  <tbody>
                    {data?.map((item, index) => {
                      return (
                        <tr
                          key={item.campaign_id}
                          className={
                            item.sub_group_item
                              ? "group/details hover:bg-slate-100 sub_group_item_bgcolor"
                              : "group/details hover:bg-slate-100"
                          }
                        >
                          <td
                            className="posrel pointer"
                            onClick={(e) => {
                              if (
                                item.grouped &&
                                (localStorage.getItem("role") === roles.ops ||
                                  localStorage.getItem("role") ===
                                    roles.financer)
                              )
                                MergeGroupedCampaigns(item.group_id);
                            }}
                          >
                            <div className="flex-hor">
                              {localStorage.getItem("role") ===
                                roles.salesperson ||
                              localStorage.getItem("role") ===
                                roles.advertiser ||
                              item.grouped === false ? (
                                <img
                                  className="svg-icon20"
                                  src={
                                    item.status === 1
                                      ? createdSVG
                                      : item.status === 2
                                      ? runningSVG
                                      : item.status === 3
                                      ? pausedSVG
                                      : item.status === 4
                                      ? completedSVG
                                      : item.status === 5
                                      ? scheduledSVG
                                      : ""
                                  }
                                  alt="status"
                                />
                              ) : null}
                              {(localStorage.getItem("role") === roles.ops ||
                                localStorage.getItem("role") ===
                                  roles.financer) &&
                                (item.grouped ? (
                                  group_index === item.group_id ? (
                                    <span className="arrow expanded">▼</span>
                                  ) : (
                                    <span className="arrow expanded">►</span>
                                  )
                                ) : (
                                  ""
                                ))}
                            </div>
                          </td>
                          <td className="p-2">
                            <div class="category">
                              {localStorage.getItem("role") !==
                                roles.advertiser && (
                                <h6
                                  class={
                                    item.type === "Editorial"
                                      ? "editorial"
                                      : item.type === "Local"
                                      ? "local"
                                      : "dfp"
                                  }
                                >
                                  {item.type}
                                </h6>
                              )}
                              <h6>
                                <sl-badge variant="neutral">
                                  {item.campaign_type || "-"}
                                </sl-badge>
                              </h6>
                              {localStorage.getItem("role") !==
                                roles.salesperson &&
                              localStorage.getItem("role") !==
                                roles.advertiser &&
                              item.grouped === true ? (
                                <span className="top-dots flex-hor gap2">
                                  {item.status_array?.filter(
                                    (sitem) => sitem === 1
                                  )?.length ? (
                                    <span className="created-dot">
                                      {
                                        item.status_array?.filter(
                                          (sitem) => sitem === 1
                                        )?.length
                                      }
                                    </span>
                                  ) : null}

                                  {item.status_array?.filter(
                                    (sitem) => sitem === 2
                                  )?.length ? (
                                    <span className="running-dot">
                                      {
                                        item.status_array?.filter(
                                          (sitem) => sitem === 2
                                        )?.length
                                      }
                                    </span>
                                  ) : null}
                                  {item.status_array?.filter(
                                    (sitem) => sitem === 3
                                  )?.length ? (
                                    <span className="paused-dot">
                                      {
                                        item.status_array?.filter(
                                          (sitem) => sitem === 3
                                        )?.length
                                      }
                                    </span>
                                  ) : null}
                                  {item.status_array?.filter(
                                    (sitem) => sitem === 4
                                  )?.length ? (
                                    <span className="completed-dot">
                                      {
                                        item.status_array?.filter(
                                          (sitem) => sitem === 4
                                        )?.length
                                      }
                                    </span>
                                  ) : null}

                                  {item.status_array?.filter(
                                    (sitem) => sitem === 5
                                  )?.length ? (
                                    <span className="scheduled-dot">
                                      {
                                        item.status_array?.filter(
                                          (sitem) => sitem === 5
                                        )?.length
                                      }
                                    </span>
                                  ) : null}
                                </span>
                              ) : null}
                            </div>
                            <h1 class="title success">
                              {/* <span className="wgt-600">{item.campaign_name}</span> */}
                              {
                                <div className="flex items-center gap-2 group/position">
                                  {
                                    <span
                                      className="wgt-600"
                                      onClick={() => {
                                        view(item);
                                      }}
                                    >
                                      {item.campaign_name}
                                    </span>
                                  }
                                </div>
                              }
                            </h1>
                            <div class="executive">
                              <p>{item.sales_name}</p>
                              <h5 class="duration flex-hor">
                                {
                                  <div className="flex gap-2 items-center group/start-date">
                                    <span className="whitespace-nowrap">
                                      {" "}
                                      {item.campaign_type === "CPD"
                                        ? formatDateWithTime(item.start_date)
                                        : formatDateWithTime(item.start_date)}
                                    </span>
                                  </div>
                                }{" "}
                                -{" "}
                                {
                                  <div className="flex items-center gap-2 group/end-date">
                                    <span className="whitespace-nowrap">
                                      {item.campaign_type === "CPD"
                                        ? formatDateWithTime(item.end_date)
                                        : formatDateWithTime(item.end_date)}
                                    </span>
                                  </div>
                                }
                              </h5>
                            </div>
                          </td>

                          <td>{item.position}</td>
                          {(localStorage.getItem("role") === roles.ops ||
                            localStorage.getItem("role") ===
                              roles.financer) && <td>{item.priority}</td>}
                          <td>
                            <div class="splitView">
                              <p>
                                {item.campaign_type === "CPD"
                                  ? item.cpd
                                  : item.daily_budget}
                              </p>
                              <div class="devider"></div>
                              <p>
                                {item.campaign_type === "CPD"
                                  ? item.cpd
                                  : item.total_budget}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div class="splitView">
                              <p>
                                {item.campaign_type === "CPC"
                                  ? item.daily_click_cap
                                  : item.campaign_type === "CPM"
                                  ? item.daily_imp_cap
                                  : "-"}
                              </p>
                              <div class="devider"></div>
                              <p>
                                {item.campaign_type === "CPC"
                                  ? item.tot_click_cap
                                  : item.campaign_type === "CPM"
                                  ? item.tot_imp_cap
                                  : "-"}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div class="splitView">
                              <p>
                                {localStorage.getItem("role") !==
                                  roles.advertiser &&
                                localStorage.getItem("role") !==
                                  roles.salesperson
                                  ? item.impclicks[0]?.total_click
                                    ? item.impclicks[0]?.total_click
                                    : 0
                                  : parseInt(
                                      item.impclicks[0]?.adv_total_click
                                        ? item.impclicks[0]?.adv_total_click
                                        : 0
                                    )}
                              </p>
                              <div class="devider"></div>
                              <p>
                                {localStorage.getItem("role") !==
                                  roles.advertiser &&
                                localStorage.getItem("role") !==
                                  roles.salesperson
                                  ? item.impclicks[0]?.total_imp
                                    ? item.impclicks[0]?.total_imp
                                    : 0
                                  : parseInt(
                                      item.impclicks[0]?.adv_total_imp
                                        ? item.impclicks[0]?.adv_total_imp
                                        : 0
                                    )}
                              </p>
                            </div>
                          </td>
                          {localStorage.getItem("role") !== roles.advertiser &&
                            localStorage.getItem("role") !==
                              roles.salesperson && (
                              <td>
                                <div class="splitView">
                                  <p>
                                    {item.impclicks[0]?.total_click > 0 &&
                                    item.impclicks[0]?.total_imp > 0
                                      ? (
                                          (item.impclicks[0].total_click /
                                            item.impclicks[0].total_imp) *
                                          100
                                        ).toFixed(2)
                                      : 0}
                                    %
                                  </p>
                                  <div class="devider"></div>
                                  <p>
                                    {!item.grouped
                                      ? item.campaign_type === "CPC" &&
                                        item.impclicks[0]?.total_click > 0 &&
                                        item.impclicks[0]?.total_imp > 0
                                        ? (
                                            ((item.cpc_price *
                                              item.impclicks[0].total_click) /
                                              item.impclicks[0].total_imp) *
                                            1000
                                          ).toFixed(2)
                                        : item.campaign_type === "CPM" &&
                                          item.impclicks[0]?.total_imp > 0
                                        ? (
                                            ((item.cpm *
                                              item.impclicks[0].total_imp) /
                                              1000 /
                                              item.impclicks[0].total_imp) *
                                            1000
                                          ).toFixed(2)
                                        : item.campaign_type === "CPD"
                                        ? item.cpd
                                        : 0
                                      : "-"}
                                  </p>
                                </div>
                              </td>
                            )}
                          {localStorage.getItem("role") !== roles.advertiser &&
                            localStorage.getItem("role") !==
                              roles.salesperson && (
                              <td>
                                <div class="splitView">
                                  <p>
                                    {parseInt(
                                      item.impclicks[0]?.adv_total_click > 0
                                        ? item.impclicks[0]?.adv_total_click
                                        : 0
                                    )}
                                  </p>
                                  <div class="devider"></div>
                                  <p>
                                    {parseInt(
                                      item.impclicks[0]?.adv_total_imp > 0
                                        ? item.impclicks[0]?.adv_total_imp
                                        : 0
                                    )}
                                  </p>
                                </div>
                              </td>
                            )}
                          {localStorage.getItem("role") !== roles.advertiser &&
                            localStorage.getItem("role") !==
                              roles.salesperson && (
                              <td>
                                <div class="splitView">
                                  <p>
                                    {item.impclicks[0]?.adv_total_click > 0 &&
                                    item.impclicks[0]?.adv_total_imp > 0
                                      ? (
                                          (item.impclicks[0].adv_total_click /
                                            item.impclicks[0].adv_total_imp) *
                                          100
                                        ).toFixed(2)
                                      : 0}
                                    %
                                  </p>
                                  <div class="devider"></div>
                                  <p>
                                    {!item.grouped
                                      ? item.campaign_type === "CPC" &&
                                        item.impclicks[0]?.adv_total_click >
                                          0 &&
                                        item.impclicks[0]?.adv_total_imp > 0
                                        ? (
                                            ((item.cpc_price *
                                              item.impclicks[0]
                                                .adv_total_click) /
                                              item.impclicks[0].adv_total_imp) *
                                            1000
                                          ).toFixed(2)
                                        : item.campaign_type === "CPM" &&
                                          item.impclicks[0]?.adv_total_imp > 0
                                        ? (
                                            ((item.cpm *
                                              item.impclicks[0].adv_total_imp) /
                                              1000 /
                                              item.impclicks[0].adv_total_imp) *
                                            1000
                                          ).toFixed(2)
                                        : item.campaign_type === "CPD"
                                        ? item.cpd
                                        : 0
                                      : "-"}
                                  </p>
                                </div>
                              </td>
                            )}
                          <td>
                            {localStorage.getItem("role") !==
                              roles.advertiser &&
                            localStorage.getItem("role") !==
                              roles.salesperson ? (
                              <div class="splitView">
                                <p>{item.total_spent}</p>
                                <div class="devider"></div>
                                <p>
                                  {localStorage.getItem("role") !==
                                    roles.advertiser &&
                                    localStorage.getItem("role") !==
                                      roles.salesperson &&
                                    item.adv_spent}
                                </p>
                              </div>
                            ) : (
                              <p>{item.total_spent}</p>
                            )}
                          </td>
                          {localStorage.getItem("role") === roles.ops && (
                            <td>
                              <div class="splitView">
                                <p>
                                  {parseInt(
                                    item.impclicks[0]?.encrypt_imp > 0
                                      ? item.impclicks[0]?.encrypt_imp
                                      : 0
                                  )}
                                </p>
                                <div class="devider"></div>
                                <p>
                                  {parseInt(
                                    item.impclicks[0]?.encrypt_adv_imp > 0
                                      ? item.impclicks[0]?.encrypt_adv_imp
                                      : 0
                                  )}
                                </p>
                              </div>
                            </td>
                          )}
                          {localStorage.getItem("role") === roles.ops && (
                            <td className="p-2">
                              {parseInt(
                                item.impclicks[0]?.actual_clicks > 0
                                  ? item.impclicks[0]?.actual_clicks
                                  : 0
                              )}
                            </td>
                          )}
                          {localStorage.getItem("role") === roles.ops && (
                            <td className="p-2">
                              {parseInt(
                                item.impclicks[0]?.shares > 0
                                  ? item.impclicks[0]?.shares
                                  : 0
                              )}
                            </td>
                          )}
                          {(localStorage.getItem("role") === roles.ops ||
                            localStorage.getItem("role") ===
                              roles.financer) && (
                            <td>{!item.grouped ? item.x_value : ""}</td>
                          )}
                          <td className="p-2 relative">
                            {
                              <span>
                                {item.campaign_type === "CPC" ||
                                item.campaign_type === "CPM" ? (
                                  "-"
                                ) : (
                                  <label
                                    className={
                                      item.payment_status === 0
                                        ? "status pending"
                                        : "status paid"
                                    }
                                  >
                                    {payments[+item.payment_status]}
                                  </label>
                                )}
                              </span>
                            }
                          </td>
                          <td
                            className="p-2 relative actionsTd"
                            style={{ fontSize: "20px" }}
                          >
                            {
                              <span
                                style={{ fontSize: "20px" }}
                                className={
                                  showActionsMenu === index
                                    ? "showMenu"
                                    : "hideMenu"
                                }
                              >
                                <sl-tooltip content="View Campaign" hoist>
                                  <sl-icon-button
                                    library="lucide"
                                    name="view"
                                    onClick={() => {
                                      editAction(
                                        index,
                                        item.campaign_id,
                                        "preview"
                                      );
                                      getSales();
                                      getAdv();
                                      getCategory();
                                      getDept();
                                      getCreativeNames(
                                        item.creative_ids,
                                        item.campaign_id,
                                        item.type,
                                        item.grouped
                                      );
                                      setTimeout(() => {
                                        setTarshow(true);
                                      }, 0);
                                    }}
                                  ></sl-icon-button>
                                </sl-tooltip>
                                <sl-tooltip content="Download" hoist>
                                  <sl-icon-button
                                    library="lucide"
                                    name="download"
                                    onClick={() => {
                                      downloadDayWiseReports(item);
                                    }}
                                  ></sl-icon-button>
                                </sl-tooltip>
                              </span>
                            }
                            {showActionsMenu !== index ? (
                              <sl-tooltip
                                content="Actions"
                                hoist
                                id="clickAction"
                              >
                                <sl-icon-button
                                  library="lucide"
                                  name="more-vertical"
                                  onClick={() => {
                                    setShowActionsMenu(index);
                                  }}
                                ></sl-icon-button>
                              </sl-tooltip>
                            ) : (
                              <sl-tooltip
                                content="Actions"
                                hoist
                                id="clickAction"
                              >
                                <sl-icon-button
                                  library="lucide"
                                  name="more-horizontal"
                                  onClick={() => {
                                    setShowActionsMenu(-1);
                                  }}
                                ></sl-icon-button>
                              </sl-tooltip>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : !data?.length && !loader ? (
                  <NoDataFound colspan="15" />
                ) : (
                  <TableLoader colspan="15" />
                )}
              </table>
            </ScrollContainer>
          </div>
          <div className="right-absolute">
            {totalPages > 1 && (
              <Paginator
                pageCount={totalPages}
                handlePageClick={handlePageClick}
                forcePage={currentPage}
              />
            )}
          </div>
          <SlDrawer
            open={tarshow}
            onSlAfterHide={() => {
              setTarshow(false);
              setTargetdetails({});
              setactual_target({});
              setCreative_Names([]);
              setPreview({});
              setGroup_target_Actual_ids([]);
              setGroup_target_dataArray([]);
            }}
            style={{ "--size": "1280px" }}
          >
            <label slot="label">{`${
              previewdata?.start?.campaign_name
                ? previewdata?.start?.campaign_name
                : ""
            }`}</label>
            <div>
              <section className="flex gap-6">
                <div className="basis-7/12 grid gap-6 grid-cols-2">
                  {
                    <>
                      {previewdata.budget ? (
                        <>
                          {
                            <>
                              <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6 className="mb-2">Campaign Creation</h6>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Advertiser Name :{" "}
                                  </label>
                                  <span>
                                    {fun(
                                      previewdata.start.advertiser_id,
                                      "advertiser"
                                    )}
                                  </span>
                                </div>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Campaign Category :{" "}
                                  </label>
                                  <span>
                                    {fun(
                                      previewdata.start.category_id,
                                      "category"
                                    )}
                                  </span>
                                </div>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Campaign Name :{" "}
                                  </label>
                                  <span>{previewdata.start.campaign_name}</span>
                                </div>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Campaign Type :{" "}
                                  </label>
                                  <span>{previewdata.start.campaign_type}</span>
                                </div>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Company Name :{" "}
                                  </label>
                                  <span>{previewdata.start.company_name}</span>
                                </div>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Department :{" "}
                                  </label>
                                  <span>
                                    {fun(
                                      previewdata.start.department,
                                      "depart"
                                    )}
                                  </span>
                                </div>
                                {previewdata.start.ro_number ? (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Ro Number :{" "}
                                    </label>
                                    <span>{previewdata.start.ro_number}</span>
                                  </div>
                                ) : null}
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Sales Name :{" "}
                                  </label>
                                  <span>
                                    {fun(previewdata.start.sales_id, "sales")}
                                  </span>
                                </div>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Type :{" "}
                                  </label>
                                  <span>{previewdata.type}</span>
                                </div>
                                {previewdata.start.brand !== null && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Brand :{" "}
                                    </label>
                                    <span>{previewdata.start.brand}</span>
                                  </div>
                                )}
                              </section>
                              <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6 className="mb-2">Budget</h6>
                                {previewdata.budget.cpc_price > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      CPC Price :{" "}
                                    </label>
                                    <span>{previewdata.budget.cpc_price}</span>
                                  </div>
                                )}

                                {previewdata.creatselect.cpd > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      CPD Price :{" "}
                                    </label>
                                    <span>{previewdata.creatselect.cpd}</span>
                                  </div>
                                )}

                                {previewdata.budget.cpm > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      CPM Price :{" "}
                                    </label>
                                    <span>{previewdata.budget.cpm}</span>
                                  </div>
                                )}

                                {previewdata.budget.daily_budget > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Daily Budget :{" "}
                                    </label>
                                    <span>
                                      {previewdata.budget.daily_budget}
                                    </span>
                                  </div>
                                )}

                                {previewdata.budget.total_budget > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Total Budget :{" "}
                                    </label>
                                    <span>
                                      {previewdata.budget.total_budget}
                                    </span>
                                  </div>
                                )}

                                {previewdata.budget.daily_click_cap > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Daily Click Cap :{" "}
                                    </label>
                                    <span>
                                      {previewdata.budget.daily_click_cap}
                                    </span>
                                  </div>
                                )}

                                {previewdata.budget.daily_imp_cap > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Daily Impression Cap :{" "}
                                    </label>
                                    <span>
                                      {previewdata.budget.daily_imp_cap}
                                    </span>
                                  </div>
                                )}

                                {previewdata.budget.tot_click_cap > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Total Click Cap :{" "}
                                    </label>
                                    <span>
                                      {previewdata.budget.tot_click_cap}
                                    </span>
                                  </div>
                                )}

                                {previewdata.budget.tot_imp_cap > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Total Impression Cap :{" "}
                                    </label>
                                    <span>
                                      {previewdata.budget.tot_imp_cap}
                                    </span>
                                  </div>
                                )}

                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Advertiser Name :{" "}
                                  </label>
                                  <span>
                                    {fun(
                                      previewdata.start.advertiser_id,
                                      "advertiser"
                                    )}
                                  </span>
                                </div>
                                {previewdata.start.campaign_type === "CPD" && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Type :{" "}
                                    </label>
                                    {fun1(previewdata.budget.payment.type)}
                                  </div>
                                )}
                                {previewdata.budget.payment.mode !== 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Mode :{" "}
                                    </label>
                                    {fun2(previewdata.budget.payment.mode)}
                                  </div>
                                )}
                                {previewdata.budget.payment.value !== 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      id :{" "}
                                    </label>
                                    {previewdata.budget.payment.value}
                                  </div>
                                )}
                              </section>
                              <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6>Create Select</h6>
                                {previewdata.creatselect.ad_code !== "" && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Ad Code :
                                    </label>{" "}
                                    {previewdata.creatselect.ad_code}
                                  </div>
                                )}
                                {previewdata.creatselect.line_item_code !==
                                  null && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Line Item Code :
                                    </label>{" "}
                                    {previewdata.creatselect.line_item_code}
                                  </div>
                                )}
                                {previewdata.creatselect.post_type !== null && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      {" "}
                                      Post Type :
                                    </label>{" "}
                                    {previewdata.creatselect.post_type}
                                  </div>
                                )}
                                {previewdata.creatselect.news_type !== null && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      {" "}
                                      News Type :
                                    </label>{" "}
                                    {previewdata.creatselect.news_type}
                                  </div>
                                )}

                                {previewdata.creatselect.creative_type !==
                                  "" && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Creative Type :
                                    </label>{" "}
                                    {previewdata.creatselect.creative_type}
                                  </div>
                                )}
                                {previewdata.creatselect.discount !== null &&
                                previewdata.creatselect.packages === "1" ? (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      package Code :
                                    </label>{" "}
                                    {previewdata.creatselect.discount}
                                  </div>
                                ) : (
                                  previewdata.creatselect.discount !== null && (
                                    <div className="flex justify-between mb-2">
                                      <label className="text-slate-500">
                                        Discount Code
                                      </label>{" "}
                                      : {previewdata.creatselect.discount}
                                    </div>
                                  )
                                )}
                                {previewdata.creatselect.packages !== null && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      package :
                                    </label>{" "}
                                    {previewdata.creatselect.packages === "1"
                                      ? "true"
                                      : "false"}
                                  </div>
                                )}
                                {previewdata.creatselect.frequency_cap > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Frequency :
                                    </label>{" "}
                                    {previewdata.creatselect.frequency_cap}
                                  </div>
                                )}
                                {previewdata.creatselect.frequency_cap_type !==
                                  "" && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Frequency Cap Type :
                                    </label>{" "}
                                    {previewdata.creatselect.frequency_cap_type}
                                  </div>
                                )}
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Position :{" "}
                                  </label>
                                  {previewdata.creatselect.position}
                                </div>
                                {previewdata.creatselect.positiontype !==
                                  "" && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Position Type :
                                    </label>{" "}
                                    {previewdata.creatselect.positiontype}
                                  </div>
                                )}
                                {previewdata.creatselect.action_type !==
                                  null && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Action type :
                                    </label>{" "}
                                    {
                                      actiontypeoptions[
                                        previewdata.creatselect.action_type
                                      ]
                                    }
                                  </div>
                                )}
                              </section>
                              <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6 className="mb-2">Date</h6>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    Start Date :
                                  </label>
                                  <span>
                                    {previewdata.start.campaign_type === "CPD"
                                      ? formatDateWithTime(
                                          previewdata.date.start_date
                                        )
                                      : formatDateWithTime(
                                          previewdata.date.start_date
                                        )}
                                  </span>
                                </div>
                                <div className="flex justify-between mb-2">
                                  <label className="text-slate-500">
                                    End Date :
                                  </label>
                                  <span>
                                    {previewdata.start.campaign_type !== "CPD"
                                      ? formatDateWithTime(
                                          previewdata.date.end_date
                                        )
                                      : formatDateWithTime(
                                          previewdata.date.end_date
                                        )}
                                  </span>
                                </div>
                                {previewdata.date.datelist.length !== 0 ? (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Day Time Slots :
                                    </label>
                                    {previewdata.date.datelist.length !== 0 ? (
                                      handleDate(previewdata.date.datelist)
                                    ) : (
                                      <div></div>
                                    )}
                                  </div>
                                ) : null}
                                <p>
                                  {previewdata.date.datelist.length !== 0
                                    ? timeslots.length > 0
                                      ? timeslots.map((item, i) => (
                                          <p key={i}>
                                            {" "}
                                            {item.sdate} {<br />} {item.edate}
                                          </p>
                                        ))
                                      : null
                                    : null}
                                </p>
                              </section>
                              <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6 className="mb-2">Target</h6>
                                {actual_target.lang_ids?.length > 0 && (
                                  <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">
                                      Languages :
                                    </label>{" "}
                                  </div>
                                )}
                                {Array.isArray(actual_target.lang_ids) &&
                                  actual_target.lang_ids.length > 0 &&
                                  targetdetails.lang_ids.map((item, i) => {
                                    if (actual_target.lang_ids.includes(item))
                                      return (
                                        <span key={i}>{langoptions[item]}</span>
                                      );
                                  })}
                                {Array.isArray(actual_target.state_ids) &&
                                  actual_target.state_ids.length > 0 && (
                                    <div>
                                      <label className="text-slate-500">
                                        States :{" "}
                                      </label>
                                      {targetdetails.state_ids.map(
                                        (item, i) => {
                                          if (
                                            actual_target.state_ids.includes(
                                              item.state_id
                                            )
                                          )
                                            return <p>{item.state_name}</p>;
                                        }
                                      )}
                                    </div>
                                  )}
                                {Array.isArray(actual_target.district_ids) &&
                                  actual_target.district_ids.length > 0 && (
                                    <div>
                                      {
                                        <label className="text-slate-500">
                                          Districts :{" "}
                                        </label>
                                      }
                                      {targetdetails.district_ids.map(
                                        (item, i) => {
                                          if (
                                            actual_target.district_ids.includes(
                                              item.dist_id
                                            )
                                          )
                                            return (
                                              <p
                                                key={i}
                                              >{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                            );
                                        }
                                      )}
                                    </div>
                                  )}
                                {Array.isArray(actual_target.ex_districts) &&
                                  actual_target.ex_districts.length > 0 && (
                                    <div>
                                      {
                                        <label className="text-slate-500">
                                          Excluded Districts :{" "}
                                        </label>
                                      }
                                      {targetdetails.district_ids.map(
                                        (item, i) => {
                                          if (
                                            actual_target.ex_districts.includes(
                                              item.dist_id
                                            )
                                          )
                                            return (
                                              <p
                                                key={i}
                                              >{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                            );
                                        }
                                      )}
                                    </div>
                                  )}
                                {(Array.isArray(targetdetails.constituency_ids) && targetdetails.constituency_ids.length > 0) && <div>
                                  {targetdetails.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                                  {targetdetails.constituency_ids.map((item, i) => {
                                    return <p key={i}>{`${item.const_name}(C), ${item.district_name}(D)`}</p>
                                  }
                                  )}
                                </div>}
                                {Array.isArray(actual_target.mandal_ids) &&
                                  actual_target.mandal_ids.length > 0 && (
                                    <div>
                                      {
                                        <label className="text-slate-500">
                                          Mandals :{" "}
                                        </label>
                                      }
                                      {targetdetails.mandal_ids.map(
                                        (item, i) => {
                                          if (
                                            actual_target.mandal_ids.includes(
                                              item.mandal_id
                                            )
                                          )
                                            return (
                                              <p
                                                key={i}
                                              >{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                            );
                                        }
                                      )}
                                    </div>
                                  )}
                                {Array.isArray(actual_target.ex_mandals) &&
                                  actual_target.ex_mandals.length > 0 && (
                                    <div>
                                      {
                                        <label className="text-slate-500">
                                          Excluded Mandals :{" "}
                                        </label>
                                      }
                                      {targetdetails.mandal_ids.map(
                                        (item, i) => {
                                          if (
                                            actual_target.ex_mandals.includes(
                                              item.mandal_id
                                            )
                                          )
                                            return (
                                              <p
                                                key={i}
                                              >{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                            );
                                        }
                                      )}
                                    </div>
                                  )}
                                {Array.isArray(actual_target.village_ids) &&
                                  actual_target.village_ids.length > 0 && (
                                    <div>
                                      {
                                        <label className="text-slate-500">
                                          villages :{" "}
                                        </label>
                                      }
                                      {targetdetails.village_ids.map(
                                        (item, i) => {
                                          if (
                                            actual_target.village_ids.includes(
                                              item.village_id
                                            )
                                          )
                                            return (
                                              <p
                                                key={i}
                                              >{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                            );
                                        }
                                      )}
                                    </div>
                                  )}
                                {Array.isArray(actual_target.ex_villages) &&
                                  actual_target.ex_villages.length > 0 && (
                                    <div>
                                      {
                                        <label className="text-slate-500">
                                          Excluded villages :{" "}
                                        </label>
                                      }
                                      {targetdetails.village_ids.map(
                                        (item, i) => {
                                          if (
                                            actual_target.ex_villages.includes(
                                              item.village_id
                                            )
                                          )
                                            return (
                                              <p
                                                key={i}
                                              >{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                            );
                                        }
                                      )}
                                    </div>
                                  )}
                                {Array.isArray(targetdetails.app_category) &&
                                  targetdetails.app_category.length > 0 && (
                                    <div>
                                      {
                                        <label className="text-slate-500">
                                          App Category :{" "}
                                        </label>
                                      }
                                      {targetdetails.app_category.map(
                                        (item, i) => (
                                          <p key={i}>
                                            {" "}
                                            {appCategoryOptions[item]}
                                          </p>
                                        )
                                      )}
                                    </div>
                                  )}
                                {Array.isArray(targetdetails.minspend) &&
                                  targetdetails.minspend.length > 0 && (
                                    <div>
                                      {
                                        <label className="text-slate-500">
                                          Minimum Spend :{" "}
                                        </label>
                                      }
                                      {targetdetails.minspend.map((item, i) => (
                                        <p key={i}>{item}</p>
                                      ))}
                                    </div>
                                  )}
                                {previewdata.target ? (
                                  <div>
                                    {previewdata.target.min_age > 0 && (
                                      <p>
                                        <label className="text-slate-500">
                                          Min Age
                                        </label>{" "}
                                        : {previewdata.target.min_age}
                                      </p>
                                    )}
                                    {previewdata.target.max_age > 0 && (
                                      <p>
                                        <label className="text-slate-500">
                                          Max Age
                                        </label>{" "}
                                        : {previewdata.target.max_age}
                                      </p>
                                    )}
                                    {previewdata.target.os !== "" && (
                                      <p>
                                        <label className="text-slate-500">
                                          OS
                                        </label>{" "}
                                        : {osOptions[previewdata.target.os]}
                                      </p>
                                    )}
                                    {genderOptions[targetdetails.gender] !==
                                      null && (
                                      <p>
                                        <label className="text-slate-500">
                                          Gender
                                        </label>{" "}
                                        : {genderOptions[targetdetails.gender]}{" "}
                                      </p>
                                    )}
                                  </div>
                                ) : null}
                              </section>
                              {group_target_dataArray.map(
                                (groupitem, index) => {
                                  return Object.keys(groupitem).length ? (
                                    <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                      {/* <h6 className="mb-2">Target</h6> */}
                                      {group_target_Actual_ids[index].lang_ids
                                        ?.length > 0 && (
                                        <div className="flex justify-between mb-2">
                                          <label className="text-slate-500">
                                            Languages :
                                          </label>{" "}
                                        </div>
                                      )}
                                      {Array.isArray(
                                        group_target_Actual_ids[index].lang_ids
                                      ) &&
                                        group_target_Actual_ids[index].lang_ids
                                          .length > 0 &&
                                        groupitem.lang_ids.map((item, i) => {
                                          if (
                                            group_target_Actual_ids[
                                              index
                                            ].lang_ids.includes(item)
                                          )
                                            return (
                                              <span key={i}>
                                                {langoptions[item]}
                                              </span>
                                            );
                                        })}
                                      {Array.isArray(
                                        group_target_Actual_ids[index].state_ids
                                      ) &&
                                        group_target_Actual_ids[index].state_ids
                                          .length > 0 && (
                                          <div>
                                            <label className="text-slate-500">
                                              States :{" "}
                                            </label>
                                            {groupitem.state_ids.map(
                                              (item, i) => {
                                                if (
                                                  group_target_Actual_ids[
                                                    index
                                                  ].state_ids.includes(
                                                    item.state_id
                                                  )
                                                )
                                                  return (
                                                    <p>{item.state_name}</p>
                                                  );
                                              }
                                            )}
                                          </div>
                                        )}
                                      {Array.isArray(
                                        group_target_Actual_ids[index]
                                          .district_ids
                                      ) &&
                                        group_target_Actual_ids[index]
                                          .district_ids.length > 0 && (
                                          <div>
                                            {
                                              <label className="text-slate-500">
                                                Districts :{" "}
                                              </label>
                                            }
                                            {groupitem.district_ids.map(
                                              (item, i) => {
                                                if (
                                                  group_target_Actual_ids[
                                                    index
                                                  ].district_ids.includes(
                                                    item.dist_id
                                                  )
                                                )
                                                  return (
                                                    <p
                                                      key={i}
                                                    >{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                  );
                                              }
                                            )}
                                          </div>
                                        )}
                                      {Array.isArray(
                                        group_target_Actual_ids[index]
                                          .ex_districts
                                      ) &&
                                        group_target_Actual_ids[index]
                                          .ex_districts.length > 0 && (
                                          <div>
                                            {
                                              <label className="text-slate-500">
                                                Excluded Districts :{" "}
                                              </label>
                                            }
                                            {groupitem.district_ids.map(
                                              (item, i) => {
                                                if (
                                                  group_target_Actual_ids[
                                                    index
                                                  ].ex_districts.includes(
                                                    item.dist_id
                                                  )
                                                )
                                                  return (
                                                    <p
                                                      key={i}
                                                    >{`${item.dist_name}(D), ${item.state_name}(S)`}</p>
                                                  );
                                              }
                                            )}
                                          </div>
                                        )}
                                      {(Array.isArray(groupitem.constituency_ids) && groupitem.constituency_ids.length > 0) && <div>
                                        {groupitem.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                                        {groupitem.constituency_ids.map((item, i) => {
                                          return <p key={i}>{`${item.const_name}(C), ${item.district_name}(D)`}</p>
                                        }
                                        )}
                                      </div>}
                                      {Array.isArray(
                                        group_target_Actual_ids[index]
                                          .mandal_ids
                                      ) &&
                                        group_target_Actual_ids[index]
                                          .mandal_ids.length > 0 && (
                                          <div>
                                            {
                                              <label className="text-slate-500">
                                                Mandals :{" "}
                                              </label>
                                            }
                                            {groupitem.mandal_ids.map(
                                              (item, i) => {
                                                if (
                                                  group_target_Actual_ids[
                                                    index
                                                  ].mandal_ids.includes(
                                                    item.mandal_id
                                                  )
                                                )
                                                  return (
                                                    <p
                                                      key={i}
                                                    >{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                  );
                                              }
                                            )}
                                          </div>
                                        )}
                                      {Array.isArray(
                                        group_target_Actual_ids[index]
                                          .ex_mandals
                                      ) &&
                                        group_target_Actual_ids[index]
                                          .ex_mandals.length > 0 && (
                                          <div>
                                            {
                                              <label className="text-slate-500">
                                                Excluded Mandals :{" "}
                                              </label>
                                            }
                                            {groupitem.mandal_ids.map(
                                              (item, i) => {
                                                if (
                                                  group_target_Actual_ids[
                                                    index
                                                  ].ex_mandals.includes(
                                                    item.mandal_id
                                                  )
                                                )
                                                  return (
                                                    <p
                                                      key={i}
                                                    >{`${item.mandal_name}(M), ${item.district_name}(D)`}</p>
                                                  );
                                              }
                                            )}
                                          </div>
                                        )}
                                      {Array.isArray(
                                        group_target_Actual_ids[index]
                                          .village_ids
                                      ) &&
                                        group_target_Actual_ids[index]
                                          .village_ids.length > 0 && (
                                          <div>
                                            {
                                              <label className="text-slate-500">
                                                villages :{" "}
                                              </label>
                                            }
                                            {groupitem.village_ids.map(
                                              (item, i) => {
                                                if (
                                                  group_target_Actual_ids[
                                                    index
                                                  ].village_ids.includes(
                                                    item.village_id
                                                  )
                                                )
                                                  return (
                                                    <p
                                                      key={i}
                                                    >{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                  );
                                              }
                                            )}
                                          </div>
                                        )}
                                      {Array.isArray(
                                        group_target_Actual_ids[index]
                                          .ex_villages
                                      ) &&
                                        group_target_Actual_ids[index]
                                          .ex_villages.length > 0 && (
                                          <div>
                                            {
                                              <label className="text-slate-500">
                                                Excluded villages :{" "}
                                              </label>
                                            }
                                            {groupitem.village_ids.map(
                                              (item, i) => {
                                                if (
                                                  group_target_Actual_ids[
                                                    index
                                                  ].ex_villages.includes(
                                                    item.village_id
                                                  )
                                                )
                                                  return (
                                                    <p
                                                      key={i}
                                                    >{`${item.village}(V), ${item.mandal_name}(M), ${item.district_name}(D), ${item.state_name}(S)`}</p>
                                                  );
                                              }
                                            )}
                                          </div>
                                        )}
                                      {Array.isArray(groupitem.app_category) &&
                                        groupitem.app_category.length > 0 && (
                                          <div>
                                            {
                                              <label className="text-slate-500">
                                                App Category :{" "}
                                              </label>
                                            }
                                            {groupitem.app_category.map(
                                              (item, i) => (
                                                <p key={i}>
                                                  {" "}
                                                  {appCategoryOptions[item]}
                                                </p>
                                              )
                                            )}
                                          </div>
                                        )}
                                      {Array.isArray(groupitem.minspend) &&
                                        groupitem.minspend.length > 0 && (
                                          <div>
                                            {
                                              <label className="text-slate-500">
                                                Minimum Spend :{" "}
                                              </label>
                                            }
                                            {groupitem.minspend.map(
                                              (item, i) => (
                                                <p key={i}>{item}</p>
                                              )
                                            )}
                                          </div>
                                        )}
                                      <div>
                                        {groupitem.min_age > 0 && (
                                          <p>
                                            <label className="text-slate-500">
                                              Min Age
                                            </label>{" "}
                                            : {groupitem.min_age}
                                          </p>
                                        )}
                                        {groupitem.max_age > 0 && (
                                          <p>
                                            <label className="text-slate-500">
                                              Max Age
                                            </label>{" "}
                                            : {groupitem.max_age}
                                          </p>
                                        )}
                                        {groupitem.os !== "" && (
                                          <p>
                                            <label className="text-slate-500">
                                              OS
                                            </label>{" "}
                                            : {osOptions[groupitem.os]}
                                          </p>
                                        )}
                                        {genderOptions[groupitem.gender] !==
                                          null && (
                                          <p>
                                            <label className="text-slate-500">
                                              Gender
                                            </label>{" "}
                                            : {genderOptions[groupitem.gender]}{" "}
                                          </p>
                                        )}
                                      </div>
                                    </section>
                                  ) : null;
                                }
                              )}
                            </>
                          }
                        </>
                      ) : (
                        <div></div>
                      )}
                    </>
                  }
                  {/* <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                            <h6 className="mb-2">Target</h6>
                                            {actual_target.lang_ids?.length ? <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div> : null}
                                            {Array.isArray(actual_target.lang_ids) && actual_target.lang_ids.length ? targetdetails.lang_ids.map((item, i) => {
                                                if (actual_target.lang_ids.includes(item))
                                                    return <span key={i}>{langoptions[item]}</span>
                                            }) : null}
                                        </section> */}
                </div>
                {previewdata.creatselect && (
                  <section className="basis-5/12 rounded-2xl overflow-hidden">
                    {
                      <>
                        {" "}
                        {creative_Names.length > 0 ? (
                          <Swiper
                            spaceBetween={0}
                            pagination={true}
                            navigation={true}
                            modules={[Navigation, Pagination]}
                            className="mySwiper"
                            style={{ width: "460px" }}
                          >
                            {creative_Names.map((campPreview) => (
                              <SwiperSlide>
                                <reportCreativeContext.Provider
                                  value={{ campPreview }}
                                >
                                  <PreviewFrameEdit showPreview={true} />
                                </reportCreativeContext.Provider>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        ) : null}{" "}
                      </>
                    }
                  </section>
                )}
              </section>
            </div>
          </SlDrawer>

          {/* <SlDrawer
        open={formshow}
        onSlAfterHide={() => {
          console.log("--------------->>>>>>")
          setFormshow(false); setcampaigndetails({}); setTab("Date wise")
        }}
        style={{ '--size': '100vw' }}
      >
        <div className="overflow-x-auto">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>IMPRESSIONS</th>
                <th>CLICKS</th>
                {localStorage.getItem("role") !== roles.advertiser && <th>ADVERTISER IMPRESSIONS</th>}
                {localStorage.getItem("role") !== roles.advertiser && <th>ADVERTISER CLICKS</th>}
                {localStorage.getItem("role") !== roles.advertiser && <th>CTR(%)</th>}
                {localStorage.getItem("role") !== roles.advertiser && <th>ECPM/CPD</th>}
                <th>TOTAL BUDGET</th>
                <th>DAILY BUDGET</th>
                <th>SPENT</th>
                {localStorage.getItem("role") !== roles.advertiser && <th>ADVERTISER SPENT</th>}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{localStorage.getItem("role") !== roles.advertiser ? (Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length ? campaigndetails.impclicks[0].total_imp : 0) : (Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length ? parseInt(campaigndetails.impclicks[0].adv_total_imp) : 0)}</td>
                <td>{localStorage.getItem("role") !== roles.advertiser ? (Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length ? campaigndetails.impclicks[0].total_click : 0) : (Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length ? parseInt(campaigndetails.impclicks[0].adv_total_click) : 0)}</td>
                {localStorage.getItem("role") !== roles.advertiser && <td> {(Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length ? parseInt(campaigndetails.impclicks[0].adv_total_imp) : 0)}</td>}
                {localStorage.getItem("role") !== roles.advertiser && <td>{(Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length ? parseInt(campaigndetails.impclicks[0].adv_total_click) : 0)}</td>}
                {localStorage.getItem("role") !== roles.advertiser && <td>{Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length && campaigndetails.impclicks[0]?.total_click > 0 && campaigndetails.impclicks[0].total_imp > 0 ? ((campaigndetails.impclicks[0].total_click / campaigndetails.impclicks[0].total_imp) * 100).toFixed(2) : 0}</td>}
                {localStorage.getItem("role") !== roles.advertiser && <td>{(campaigndetails.campaign_type === "CPC" && campaigndetails.impclicks[0]?.total_click > 0 && campaigndetails.impclicks[0]?.total_imp > 0 ? (((campaigndetails.cpc_price * campaigndetails.impclicks[0]?.total_click) / (campaigndetails.impclicks[0]?.total_imp)) * 1000).toFixed(2) : campaigndetails.campaign_type === "CPM" && campaigndetails.impclicks[0]?.total_imp > 0 ? ((((campaigndetails.cpm * campaigndetails.impclicks[0]?.total_imp) / 1000) / campaigndetails.impclicks[0]?.total_imp) * 1000).toFixed(2) : campaigndetails.campaign_type === "CPD" ? campaigndetails.cpd : "0")}</td>}
                <td>{parseInt(campaigndetails.total_budget) === 0 ? campaigndetails.cpd : campaigndetails.total_budget}</td>
                <td>{parseInt(campaigndetails.daily_budget) === 0 ? campaigndetails.cpd : campaigndetails.daily_budget}</td>
                <td>{localStorage.getItem("role") !== roles.advertiser ? (parseInt(campaigndetails.total_budget) === 0 ? campaigndetails.cpd : Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length && (campaigndetails.impclicks[0]?.total_click > 0 || campaigndetails.impclicks[0].total_imp > 0) ? (campaigndetails.campaign_type === "CPC" ? (parseFloat(campaigndetails.cpc_price) * campaigndetails.impclicks[0].total_click).toFixed(2) : campaigndetails.campaign_type === "CPM" ? ((parseFloat(campaigndetails.cpm) * campaigndetails.impclicks[0].total_imp) / 1000).toFixed(2) : 0) : "0") : (parseInt(campaigndetails.total_budget) === 0 ? campaigndetails.cpd : Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length && (campaigndetails.impclicks[0]?.adv_total_click > 0 || campaigndetails.impclicks[0].adv_total_imp > 0) ? (campaigndetails.campaign_type === "CPC" ? (parseFloat(campaigndetails.cpc_price) * campaigndetails.impclicks[0].adv_total_click).toFixed(2) : campaigndetails.campaign_type === "CPM" ? ((parseFloat(campaigndetails.cpm) * campaigndetails.impclicks[0].adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>
                {localStorage.getItem("role") !== roles.advertiser && <td>{(parseInt(campaigndetails.total_budget) === 0 ? campaigndetails.cpd : Array.isArray(campaigndetails.impclicks) && campaigndetails.impclicks.length && (campaigndetails.impclicks[0]?.adv_total_click > 0 || campaigndetails.impclicks[0].adv_total_imp > 0) ? (campaigndetails.campaign_type === "CPC" ? (parseFloat(campaigndetails.cpc_price) * campaigndetails.impclicks[0].adv_total_click).toFixed(2) : campaigndetails.campaign_type === "CPM" ? ((parseFloat(campaigndetails.cpm) * campaigndetails.impclicks[0].adv_total_imp) / 1000).toFixed(2) : 0) : "0")}</td>}
              </tr>
            </tbody>
          </table>
          {
            <div className="form-floating">
              <SlTabGroup onSlTabShow={handleTabActivate}>
                <SlTab slot="nav" panel="Date wise">Date wise</SlTab>
                <SlTabPanel name="Date wise"> {tab === "Date wise" && <DayWiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></DayWiseReport>}</SlTabPanel>
                <SlTab slot="nav" panel="Creative wise">Creative wise</SlTab>
                {<SlTabPanel name="Creative wise"> {tab === "Creative wise" && <CreativewiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails} ></CreativewiseReport>}</SlTabPanel>}
                {
                 ((localStorage.getItem("role") !== roles.advertiser) && (localStorage.getItem("role") !== roles.salesperson)) &&
                  <>
                    <SlTab slot="nav" panel="Langwise">Language wise</SlTab>
                    <SlTabPanel name="Langwise">{tab === "Langwise" && <LangwiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></LangwiseReport>}</SlTabPanel>
                    <SlTab slot="nav" panel="Statewise">State wise</SlTab>
                    <SlTabPanel name="Statewise">{tab === "Statewise" && <StatewiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></StatewiseReport>}</SlTabPanel>
                    <SlTab slot="nav" panel="Districtwise">District wise</SlTab>
                    <SlTabPanel name="Districtwise">{tab === "Districtwise" && <DistrictwiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></DistrictwiseReport>}</SlTabPanel>
                    <SlTab slot="nav" panel="Mandalwise">Mandal wise</SlTab>
                    <SlTabPanel name="Mandalwise">{tab === "Mandalwise" && <MandalwiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></MandalwiseReport>}</SlTabPanel>
                    <SlTab slot="nav" panel="Oswise">OS wise</SlTab>
                    <SlTabPanel name="Oswise">{tab === "Oswise" && <OswiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></OswiseReport>}</SlTabPanel>
                    <SlTab slot="nav" panel="Modelwise">Model wise</SlTab>
                    <SlTabPanel name="Modelwise">{tab === "Modelwise" && <ModelwiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></ModelwiseReport>}</SlTabPanel>
                    <SlTab slot="nav" panel="Brandwise">Brand wise</SlTab>
                    <SlTabPanel name="Brandwise">{tab === "Brandwise" && <BrandwiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></BrandwiseReport>}</SlTabPanel>
                    <SlTab slot="nav" panel="Categorywise">Category wise</SlTab>
                    <SlTabPanel name="Categorywise">{tab === "Categorywise" && <CategorywiseReport campaign_id={campaigndetails.campaign_id} camp={campaigndetails}></CategorywiseReport>}</SlTabPanel>
                  </>}
              </SlTabGroup>
            </div>
          }
        </div>
      </SlDrawer> */}

          <Modal
            show={formshow}
            backdrop="static"
            keyboard={false}
            onHide={() => {
              setFormshow(false);
              setcampaigndetails({});
              setTab("Date wise");
            }}
            dialogClassName="modal-fullscreen"
            contentClassName="modal-height"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-sm">
                {campaigndetails.campaign_name}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <table className=" table table-bordered">
                <thead>
                  <tr>
                    {localStorage.getItem("role") === roles.advertiser ? (
                      <th>Audience Viewed</th>
                    ) : localStorage.getItem("role" === roles.salesperson) ? (
                      <th scope="col">Impressions</th>
                    ) : (
                      <th>Impressions</th>
                    )}
                    {localStorage.getItem("role") === roles.advertiser ? (
                      <th>Audience Engaged</th>
                    ) : localStorage.getItem("role" === roles.salesperson) ? (
                      <th scope="col">Clicks</th>
                    ) : (
                      <th>Clicks</th>
                    )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <th>ADVERTISER IMPRESSIONS</th>
                      )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <th>ADVERTISER CLICKS</th>
                      )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <th>CTR(%)</th>
                      )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <th>ECPM/CPD</th>
                      )}
                    <th>TOTAL BUDGET</th>
                    <th>DAILY BUDGET</th>
                    <th>SPENT</th>
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <th>ADVERTISER SPENT</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson
                        ? Array.isArray(campaigndetails.impclicks) &&
                          campaigndetails.impclicks.length
                          ? campaigndetails.impclicks[0].total_imp
                          : 0
                        : Array.isArray(campaigndetails.impclicks) &&
                          campaigndetails.impclicks.length
                        ? parseInt(campaigndetails.impclicks[0].adv_total_imp)
                        : 0}
                    </td>
                    <td>
                      {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson
                        ? Array.isArray(campaigndetails.impclicks) &&
                          campaigndetails.impclicks.length
                          ? campaigndetails.impclicks[0].total_click
                          : 0
                        : Array.isArray(campaigndetails.impclicks) &&
                          campaigndetails.impclicks.length
                        ? parseInt(campaigndetails.impclicks[0].adv_total_click)
                        : 0}
                    </td>
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <td>
                          {" "}
                          {Array.isArray(campaigndetails.impclicks) &&
                          campaigndetails.impclicks.length
                            ? parseInt(
                                campaigndetails.impclicks[0].adv_total_imp
                              )
                            : 0}
                        </td>
                      )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <td>
                          {Array.isArray(campaigndetails.impclicks) &&
                          campaigndetails.impclicks.length
                            ? parseInt(
                                campaigndetails.impclicks[0].adv_total_click
                              )
                            : 0}
                        </td>
                      )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <td>
                          {Array.isArray(campaigndetails.impclicks) &&
                          campaigndetails.impclicks.length &&
                          campaigndetails.impclicks[0]?.total_click > 0 &&
                          campaigndetails.impclicks[0].total_imp > 0
                            ? (
                                (campaigndetails.impclicks[0].total_click /
                                  campaigndetails.impclicks[0].total_imp) *
                                100
                              ).toFixed(2)
                            : 0}
                        </td>
                      )}
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <td>
                          {campaigndetails.campaign_type === "CPC" &&
                          campaigndetails.impclicks[0]?.total_click > 0 &&
                          campaigndetails.impclicks[0]?.total_imp > 0
                            ? (
                                ((campaigndetails.cpc_price *
                                  campaigndetails.impclicks[0]?.total_click) /
                                  campaigndetails.impclicks[0]?.total_imp) *
                                1000
                              ).toFixed(2)
                            : campaigndetails.campaign_type === "CPM" &&
                              campaigndetails.impclicks[0]?.total_imp > 0
                            ? (
                                ((campaigndetails.cpm *
                                  campaigndetails.impclicks[0]?.total_imp) /
                                  1000 /
                                  campaigndetails.impclicks[0]?.total_imp) *
                                1000
                              ).toFixed(2)
                            : campaigndetails.campaign_type === "CPD"
                            ? campaigndetails.cpd
                            : "0"}
                        </td>
                      )}
                    <td>
                      {parseInt(campaigndetails.total_budget) === 0
                        ? campaigndetails.cpd
                        : campaigndetails.total_budget}
                    </td>
                    <td>
                      {parseInt(campaigndetails.daily_budget) === 0
                        ? campaigndetails.cpd
                        : campaigndetails.daily_budget}
                    </td>
                    <td>
                      {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson
                        ? parseInt(campaigndetails.total_budget) === 0
                          ? campaigndetails.cpd
                          : Array.isArray(campaigndetails.impclicks) &&
                            campaigndetails.impclicks.length &&
                            (campaigndetails.impclicks[0]?.total_click > 0 ||
                              campaigndetails.impclicks[0].total_imp > 0)
                          ? campaigndetails.campaign_type === "CPC"
                            ? (
                                parseFloat(campaigndetails.cpc_price) *
                                campaigndetails.impclicks[0].total_click
                              ).toFixed(2)
                            : campaigndetails.campaign_type === "CPM"
                            ? (
                                (parseFloat(campaigndetails.cpm) *
                                  campaigndetails.impclicks[0].total_imp) /
                                1000
                              ).toFixed(2)
                            : 0
                          : "0"
                        : parseInt(campaigndetails.total_budget) === 0
                        ? campaigndetails.cpd
                        : Array.isArray(campaigndetails.impclicks) &&
                          campaigndetails.impclicks.length &&
                          (campaigndetails.impclicks[0]?.adv_total_click > 0 ||
                            campaigndetails.impclicks[0].adv_total_imp > 0)
                        ? campaigndetails.campaign_type === "CPC"
                          ? (
                              parseFloat(campaigndetails.cpc_price) *
                              campaigndetails.impclicks[0].adv_total_click
                            ).toFixed(2)
                          : campaigndetails.campaign_type === "CPM"
                          ? (
                              (parseFloat(campaigndetails.cpm) *
                                campaigndetails.impclicks[0].adv_total_imp) /
                              1000
                            ).toFixed(2)
                          : 0
                        : "0"}
                    </td>
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <td>
                          {parseInt(campaigndetails.total_budget) === 0
                            ? campaigndetails.cpd
                            : Array.isArray(campaigndetails.impclicks) &&
                              campaigndetails.impclicks.length &&
                              (campaigndetails.impclicks[0]?.adv_total_click >
                                0 ||
                                campaigndetails.impclicks[0].adv_total_imp > 0)
                            ? campaigndetails.campaign_type === "CPC"
                              ? (
                                  parseFloat(campaigndetails.cpc_price) *
                                  campaigndetails.impclicks[0].adv_total_click
                                ).toFixed(2)
                              : campaigndetails.campaign_type === "CPM"
                              ? (
                                  (parseFloat(campaigndetails.cpm) *
                                    campaigndetails.impclicks[0]
                                      .adv_total_imp) /
                                  1000
                                ).toFixed(2)
                              : 0
                            : "0"}
                        </td>
                      )}
                  </tr>
                </tbody>
              </table>

              {
                <div className="form-floating">
                  <SlTabGroup onSlTabShow={handleTabActivate}>
                    <SlTab slot="nav" panel="Date wise">
                      Date wise
                    </SlTab>
                    <SlTabPanel name="Date wise">
                      {" "}
                      {tab === "Date wise" && (
                        <DayWiseReport
                          campaign_id={campaigndetails.campaign_id}
                          camp={campaigndetails}
                        ></DayWiseReport>
                      )}
                    </SlTabPanel>
                    <SlTab slot="nav" panel="Creative wise">
                      Creative wise
                    </SlTab>
                    {
                      <SlTabPanel name="Creative wise">
                        {" "}
                        {tab === "Creative wise" && (
                          <CreativewiseReport
                            campaign_id={campaigndetails.campaign_id}
                            camp={campaigndetails}
                          ></CreativewiseReport>
                        )}
                      </SlTabPanel>
                    }
                    {localStorage.getItem("role") !== roles.advertiser &&
                      localStorage.getItem("role") !== roles.salesperson && (
                        <>
                          <SlTab slot="nav" panel="Langwise">
                            Language wise
                          </SlTab>
                          <SlTabPanel name="Langwise">
                            {tab === "Langwise" && (
                              <LangwiseReport
                                campaign_id={campaigndetails.campaign_id}
                                camp={campaigndetails}
                              ></LangwiseReport>
                            )}
                          </SlTabPanel>
                          <SlTab slot="nav" panel="Statewise">
                            State wise
                          </SlTab>
                          <SlTabPanel name="Statewise">
                            {tab === "Statewise" && (
                              <StatewiseReport
                                campaign_id={campaigndetails.campaign_id}
                                camp={campaigndetails}
                              ></StatewiseReport>
                            )}
                          </SlTabPanel>
                          <SlTab slot="nav" panel="Districtwise">
                            District wise
                          </SlTab>
                          <SlTabPanel name="Districtwise">
                            {tab === "Districtwise" && (
                              <DistrictwiseReport
                                campaign_id={campaigndetails.campaign_id}
                                camp={campaigndetails}
                              ></DistrictwiseReport>
                            )}
                          </SlTabPanel>
                          <SlTab slot="nav" panel="Mandalwise">
                            Mandal wise
                          </SlTab>
                          <SlTabPanel name="Mandalwise">
                            {tab === "Mandalwise" && (
                              <MandalwiseReport
                                campaign_id={campaigndetails.campaign_id}
                                camp={campaigndetails}
                              ></MandalwiseReport>
                            )}
                          </SlTabPanel>
                          <SlTab slot="nav" panel="Oswise">
                            OS wise
                          </SlTab>
                          <SlTabPanel name="Oswise">
                            {tab === "Oswise" && (
                              <OswiseReport
                                campaign_id={campaigndetails.campaign_id}
                                camp={campaigndetails}
                              ></OswiseReport>
                            )}
                          </SlTabPanel>
                          <SlTab slot="nav" panel="Modelwise">
                            Model wise
                          </SlTab>
                          <SlTabPanel name="Modelwise">
                            {tab === "Modelwise" && (
                              <ModelwiseReport
                                campaign_id={campaigndetails.campaign_id}
                                camp={campaigndetails}
                              ></ModelwiseReport>
                            )}
                          </SlTabPanel>
                          <SlTab slot="nav" panel="Brandwise">
                            Brand wise
                          </SlTab>
                          <SlTabPanel name="Brandwise">
                            {tab === "Brandwise" && (
                              <BrandwiseReport
                                campaign_id={campaigndetails.campaign_id}
                                camp={campaigndetails}
                              ></BrandwiseReport>
                            )}
                          </SlTabPanel>
                          <SlTab slot="nav" panel="Categorywise">
                            Category wise
                          </SlTab>
                          <SlTabPanel name="Categorywise">
                            {tab === "Categorywise" && (
                              <CategorywiseReport
                                campaign_id={campaigndetails.campaign_id}
                                camp={campaigndetails}
                              ></CategorywiseReport>
                            )}
                          </SlTabPanel>
                        </>
                      )}
                  </SlTabGroup>
                </div>
              }
            </Modal.Body>
          </Modal>
        </div>
      )}
      {reportType === "consolidated" && (
        <ConsolidatedReport month={month} year={year} newReports={newReports} />
      )}
      {reportType === "ecpm" && <EcpmReport month={month} year={year} newReports={newReports} />}
      {reportType === "teamwise" && (
        <TeamwiseReports month={month} year={year} newReports={newReports} />
      )}
      {reportType === "salesPerson" && (
        <SalesPersonwiseReport month={month} year={year} newReports={newReports} />
      )}
      {reportType === "comparison" && (
        <ComparisonReport month={month} year={year} newReports={newReports} />
      )}
      {reportType === "consolidatedNational" &&(
        <ConsolidatedNational  month={month} year={year} newReports={newReports}/>
      )}
      {
        reportType === "teamwiseNational" && (
          <TeamwiseNational month={month} year = {year}  newReports={newReports} />
        )
      }
      {
        reportType === "9" && (<InboundSaleCampaigns team={reportType}/>)
      }
      {
        reportType === "2" && (<LocalSalesCampaigns team={reportType}/>)
      }
      {
        reportType === "3" && (<MetroSalesCampaigns team={reportType}/>)
      }
      {
        reportType === "5" && (<AlphaSalesCampaigns team={reportType}/>)
      }
      {
        reportType === "package_ad_report" && (<PackageAdReport month={month} year ={year} Months={Months}/>)
      }
      {
        reportType === "finance_report" && (<FinanceReport month={month} year ={year} Months={Months}/>)
      }
      {
        (reportType === "positionwise_impressions" && positionwiseImp) && (<PositionwiseImpressions></PositionwiseImpressions>)
      }

      {
        reportType === "alpha" && <AlphaTeamReports month={month} year={year} newReports={newReports} />
      }

      <SlDrawer
        label="Send Reports"
        open={showWhatsapp}
        onSlRequestClose={handleWhatsapp}
        backdrop="static"
        onSlAfterHide={() => setShowWhatsapp(false)}
      >
        <div>
          <form onSubmit={handleSubmit(sendWhatsappMessage)}>
            <label className="form-label">Enter Whatsapp numbers</label>
            <textarea
              placeholder="Input upto 10 comma separated mobile numbers"
              rows={5}
              className="form-control"
              {...register("mobileNums", {
                required: true,
                onChange: (e) => setMobileNumbers(e.target.value),
                pattern: {
                  value: /^([6-9]\d{9},){0,9}[6-9]\d{9}$/,
                  message: "Enter valid mobile numbers",
                },
              })}
            />
            {errors.mobileNums && (
              <p className="text-red-600">Please Enter Valid Mobile Number</p>
            )}
            <button
              type="submit"
              style={{ backgroundColor: "#69d769" }}
              className="w-100 text-center mt-1 mr-3 text-white btn"
            >
              {sendClicked ? (
                <>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Sending...
                </>
              ) : (
                "Send"
              )}
            </button>
          </form>
        </div>
      </SlDrawer>
    </>
  );
}

export default Reports;
